import { loadStripe } from "@stripe/stripe-js"
import { AppConfiguration } from "config"


import americanImage from "assets/images/icons/icons8-american-express.svg"
import mastercardImage from "assets/images/icons/icons8-mastercard-logo.svg"
import visaImage from "assets/images/icons/icons8-visa.svg"
import dinersClubImage from "assets/images/icons/icons8-diners-club.svg"
import discoverImage from "assets/images/icons/icons8-discover-card.svg"
import jcbImage from "assets/images/icons/jcb-image.svg"
import { ORDER_BY, SF_INVOICE_CONSTANTS } from "common/sf_strings"
export const logo = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/logo.svg`
export const logoLightPng = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/logo-light.png`
export const logoLightSvg = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/logo-light.svg`
export const logoDark = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/logo-dark.png`
export const loginlogo = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/login-logo.png`
export const animatedlogo = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/animated-logo.gif`
export const resetPasswordloginlogo = `/../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/login-logo.png`
export const resetPasswordanimatedlogo = `/../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/animated-logo.gif`
export const previewCheckMark = `/assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/checkmark.png`
export const previewStars = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/stars.png`
export const previewButton = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/button.png`
export const closeioIcon = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/closeio.png`
export const preloaderGif = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/preloader.gif`
export const preloaderWithBg = `../../assets/images/whitelabels/${AppConfiguration.PRODUCT_NAME}/preloaderWithBg.gif`
export const consentBadge = `../../assets/images/consent-badge.png`
export const INFINITY = "2147483647"
export const MIN_NUM_HOURS_FOR_RETAIL_ACCOUNTS = 25
export const CAMPAIGN_SCHEDULE_ACTIVE_HOURS_MSG = {
    MIN_25_HOURS_MSG: "(A minimum of 25 hours per week is required)",
}
import { WHITE_LABELED_PRODUCT_NAMES } from "config";
import { isIABrand } from "config"

const capitalizeWord = (word) => {
    if (word && typeof word === 'string') {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }
    return '';
};

export const MODIFICATION_TYPE = {
    new: 'new',
    update: 'update',
    delete: 'delete',
}

export const OTP_STRINGS = {
    authenticator_message: 'Please enter the OTP from your authenticator app',
    email_message: 'Please check the OTP sent to your email'
}

export const CATAGORY_LIMIT = 20
export const MIN_CAR_FIFTY = 50

export const PRODUCT_TYPE_IDS = {
    CLICKS: 1,
    CALLS: 2,
    LEADS: 3,
    SYNDI_CLICKS: 4,
    QUOTE_FUNNELS: 5
}

export const BOOLEAN_FILTER_OPTIONS = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
]

export const LEAD_TYPE_IDS = {
    AUTO: 6,
    HOME: 1,
    HEALTH: 3,
    GROUP_HEALTH: 12,
    LIFE: 2,
    MEDICARE: 7,
    COMMERCIAL: 5,
    P_C_BUNDLE: 8,
    MOTORCYCLE: 9
}

export const BUSINESS_LEAD_TYPES = [LEAD_TYPE_IDS.COMMERCIAL, LEAD_TYPE_IDS.GROUP_HEALTH];

export const NAME_OF_PRODUCT_TYPES = {
    CLICKS: "clicks",
    CALLS: "calls",
    LEADS: "leads",
    SYNDI_CLICKS: "syndi clicks",
    QUOTE_FUNNELS: 'quote funnels'
}

// Product types that require source type filtering
// Used in Analytics page to conditionally show source type filter
// "" IS FOR ALL PRODUCTS
export const REQUIRED_PRODUCT_TYPES = [
    "",
    NAME_OF_PRODUCT_TYPES.CLICKS,
    NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS,
    NAME_OF_PRODUCT_TYPES.CALLS,
    NAME_OF_PRODUCT_TYPES.LEADS,
    NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS
]

export const PRODUCT_TYPES = (() => {
    switch (AppConfiguration.PRODUCT_NAME) {
        case WHITE_LABELED_PRODUCT_NAMES.GOAL:
            return [
                {
                    id: PRODUCT_TYPE_IDS.QUOTE_FUNNELS,
                    name: NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS
                }
            ];
        case WHITE_LABELED_PRODUCT_NAMES.BENEPATH:
            return [
                {
                    id: PRODUCT_TYPE_IDS.CLICKS,
                    name: NAME_OF_PRODUCT_TYPES.CLICKS
                },
                {
                    id: PRODUCT_TYPE_IDS.CALLS,
                    name: NAME_OF_PRODUCT_TYPES.CALLS
                },
                {
                    id: PRODUCT_TYPE_IDS.LEADS,
                    name: NAME_OF_PRODUCT_TYPES.LEADS
                }
            ];
        default:
            return [
                {
                    id: PRODUCT_TYPE_IDS.CLICKS,
                    name: NAME_OF_PRODUCT_TYPES.CLICKS
                },
                {
                    id: PRODUCT_TYPE_IDS.CALLS,
                    name: NAME_OF_PRODUCT_TYPES.CALLS
                },
                {
                    id: PRODUCT_TYPE_IDS.LEADS,
                    name: NAME_OF_PRODUCT_TYPES.LEADS
                },
                {
                    id: PRODUCT_TYPE_IDS.SYNDI_CLICKS,
                    name: NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS
                }
            ];
    }
})();

export const PRODUCT_TYPES_OPTIONS = PRODUCT_TYPES.map(element => ({ value: element.id, label: capitalizeWord(element.name) }));

export const NAME_OF_LEAD_TYPES = {
    AUTO: "auto",
    HOME: "home",
    HEALTH: "health",
    LIFE: "life",
    MEDICARE: "medicare",
    COMMERCIAL: "commercial",
    P_C_BUNDLE: "P&C Bundle",
    MOTORCYCLE: "motorcycle",
    GROUP_HEALTH: "Group Health"
}
export const NAME_OF_QUOTE_FUNNEL_LEAD_TYPES = {
    AUTO: "auto",
    HOME: "home",
    HEALTH: "health",
    LIFE: "life",
    MEDICARE: "medicare",
    COMMERCIAL: "commercial",
    RENTERS: "renters",
    CONDO: "condo",
    RV: "rv",
    MOTORCYCLE: "motorcycle",
    BOAT: "boat",
    ATV: "atv",
};

export const NAME_OF_OLD_LEAD_TYPES = {
    AUTO: "auto",
    HOME: "home",
    HEALTH: "health",
    LIFE: "life",
    RENTERS: "renters",
    MEDICARE: "medicare",
    COMMERCIAL: "commercial",
    P_C_BUNDLE: "P&C Bundle"
}

export const LEAD_TYPES = [
    {
        id: 6,
        name: NAME_OF_LEAD_TYPES.AUTO,
        bx_icon: <i className="me-2 bx fs-20 bx-car" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />
    },
    {
        id: 1,
        name: NAME_OF_LEAD_TYPES.HOME,
        bx_icon: <i className="me-2 bx fs-20 bx-home" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />
    },
    {
        id: 3,
        name: NAME_OF_LEAD_TYPES.HEALTH,
        bx_icon: <i className="me-2 bx fs-20 bx-heart" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />
    },
    {
        id: 12,
        name: NAME_OF_LEAD_TYPES.GROUP_HEALTH,
        bx_icon: <i className="me-2 bx fs-20 bx-heart-circle" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />
    },
    {
        id: 2,
        name: NAME_OF_LEAD_TYPES.LIFE,
        bx_icon: <i className="me-2 bx fs-20 bx-check-shield" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />
    },
    {
        id: 5,
        name: NAME_OF_LEAD_TYPES.COMMERCIAL,
        bx_icon: <i className="me-2 bx fs-20 bx-buildings" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />
    },
    {
        id: 7,
        name: NAME_OF_LEAD_TYPES.MEDICARE,
        bx_icon: <i className="me-2 bx fs-20 bx-plus-medical" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />
    },
    {
        id: 8,
        name: NAME_OF_LEAD_TYPES.P_C_BUNDLE
    },
    {
        id: 9,
        name: NAME_OF_LEAD_TYPES.MOTORCYCLE
    }
]
export const QUOTE_FUNNEL_LEAD_TYPES = [
    {
        id: 6,
        name: "Auto Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-car" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 1,
        name: "Home Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-home" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 3,
        name: "Health Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-heart" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 2,
        name: "Life Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-check-shield" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 5,
        name: "Commercial Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-buildings" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 7,
        name: "Medicare",
        bx_icon: <i className="me-2 bx fs-20 bx-plus-medical" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 9,
        name: "Renters Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-home-alt" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 10,
        name: "Condo Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-home-alt-2" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 11,
        name: "RV Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-car-camper" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 12,
        name: "Motorcycle Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-motorbike" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 13,
        name: "Boat Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-ship" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
    {
        id: 14,
        name: "ATV Insurance",
        bx_icon: <i className="me-2 bx fs-20 bx-atv" style={{ color: AppConfiguration.PRODUCT_FAV_COLOR }} />,
    },
];

export const LEAD_TYPES_OPTIONS = LEAD_TYPES.map(element => ({ value: element.id, label: capitalizeWord(element.name) }));

export const LEAD_TYPES_OPTIONS_FOR_QUOTE_FUNNEL = QUOTE_FUNNEL_LEAD_TYPES?.map(element => ({ value: element.id, label: capitalizeWord(element.name) }));


export const INTEGRATION_LEAD_TYPES = LEAD_TYPES.filter(type => ![NAME_OF_LEAD_TYPES.P_C_BUNDLE].includes(type.name));

export const GEO_LABELS = {
    STATE: 'State',
    CITY: 'City',
    COUNTY: 'County',
    ZIP_CODE: 'Zip Code',
    ZIP_CODE_BULK: 'Zip Code (Bulk)',
    AREA_CODE: 'Area Code'
};

// TODO: change single select to lower-case (needs change on db first)
export const SfFilterTypes = {
    SINGLE_SELECT: 'single-select',
    MULTI_SELECT: 'multi-select',
    MIN_MAX: 'min-max',
    FREE_FORM: 'free-form'
}

export const SfFilterRelationalOperators = {
    EQUAL_TO: "Equal To",
    LESS_THAN: "Less Than",
    MORE_THAN: "More Than",
    BETWEEN: "Between"
}

export const OPTIONS_DISTRIBUTION_SETTINGS = [
    { label: "Preferred Placement", value: false },
    { label: "ERPC", value: true }
];

const _getArrayElementByKey = ((arr, key, value) => {
    return arr.find(elem => elem[key] === value)
})

export const getProductTypeById = ((id) => {
    return _getArrayElementByKey(PRODUCT_TYPES, 'id', id)
})

export const getProductTypeByName = ((name) => {
    return _getArrayElementByKey(PRODUCT_TYPES, 'name', name)
})

export const getLeadTypeById = ((id) => {
    return _getArrayElementByKey(LEAD_TYPES, 'id', id)
})

export const getLeadTypeByName = ((name) => {
    return _getArrayElementByKey(LEAD_TYPES, 'name', name)
})

export const SF_AGE_IN_YEARS = 2

export const CAMPAIGN_TABLE_COLMN_NAME = {
    ACTION: "action",
    NAME: "name",
    DAILY_LIMIT: "daily_limit",
    MONTHLY_LIMIT: "monthly_limit",
}

export const CAMPAIGN_NAME_INPUT_MAX_LENGTH = 35
export const CAMPAIGN_NAME_INPUT_MAX_LENGTH_RTB_WHITELABEL_INTERNAL = 70

export const ADGROUP_TABLE_COLMN_NAMES = {
    ACTION: "action",
    NAME: "name",
    BID: "bid",
    RTB_CM: "rtb_cm"
}

export const SOURCE_TABLE_COLMN_NAMES = {
    ACTION: "action",
    BID: "bid",
    NAME: "name"
}

export const TABLE_COLMN_NAMES = {
    ACTION: "action",
    NAME: "name",
    DESCRIPTION: "description",
    DAILY_LIMIT: "daily_limit",
    MONTHLY_LIMIT: "monthly_limit",
    BID: "bid",
    OPTIONS: "options",
    SALES_MANAGER: "sales_manager",
    ACCOUNT_MANAGER: "account_manager",
    STATUS: "status",
    PRICE: "price",
    BRAND_USER: "brand_user",
}

// Marker class on the inline disposition editor (toggle + react-select + Save/Cancel) so the
// page level "close on outside click" handlers can tell an inside click from an outside one.
export const DISPOSITION_EDITOR_CLASS = 'sf-disposition-editor'

// The react-select menu is portalled to <body> so it can escape the table's scroll container
// (.sfTable-Container is max-height 50vh / overflow-y scroll, which clipped the option list).
// That puts the options outside the editor's DOM subtree, so match the portal as "inside" too.
export const DISPOSITION_EDITOR_SELECTOR = `.${DISPOSITION_EDITOR_CLASS}, .sf_dropdown_popup__menu-portal`

export const LEAD_REFUND_STATUS = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    DENIED: 'DENIED'
}

export const stripePromise = loadStripe(AppConfiguration.STRIPE_PUBLISHABLE_KEY);

export const CARD_OPTIONS = {
    iconStyle: "solid",
    style: {
        base: {
            iconColor: "#c4f0ff",
            color: "#000000",
            background: "black",
            fontWeight: 700,
            fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
            fontSize: "16px",
            fontSmoothing: "antialiased",
        },
        invalid: {
            iconColor: "red",
            color: "red"
        }
    }
}
export const USER_NOTIFICATION_BANNER_TYPE = {
    SUCCESS: "success",
    DANGER: "danger",
    WARNING: "warning",
    INFO: "info"
}

export const FREQUENCY_WEIGHT_TYPE = {

    SPLIT_EVENLY: "split_evenly",
    SYSTEM_OPTIMIZED: "system_optimized",
    MANUAL: "manual",
}

export const add_funds_options_billing = [
    { label: '250', value: 250 },
    { label: '500', value: 500 },
    { label: '1000', value: 1000 },
    { label: '1500', value: 1500 },
    { label: '2000', value: 2000 },
    { label: '2500', value: 2500 },
    { label: '3000', value: 3000 },
    { label: '3500', value: 3500 },
    { label: '4000', value: 4000 },
    { label: '4500', value: 4500 },
    { label: '5000', value: 5000 },
    { label: '5500', value: 5500 },
    { label: '6000', value: 6000 },
    { label: '6500', value: 6500 },
    { label: '7000', value: 7000 },
    { label: '7500', value: 7500 },
    { label: '8000', value: 8000 },
    { label: '8500', value: 8500 },
    { label: '9000', value: 9000 },
    { label: '9500', value: 9500 },
    { label: '10000', value: 10000 }
]

export const LEAD_TYPE_ARRAY = LEAD_TYPES.map(element => ({ value: element.name, name: "lead_type" }));

export const CALL_TYPE_CAMPAIGN_NAME = {
    ALL_CALLS: "All Calls",
    INBOUND_ONLY: "Inbound Only",
    ALL_CALLS_TOOLTIP: "Includes both inbound and outbound calls generated on our consumer platform.",
    INBOUND_ONLY_TOOLTIP: "Inbound calls only. Includes consumer initiated calls like click to call, IVR etc."
}

export const CALL_TYPE_CAMPAIGN_OPTIONS = [
    {
        value: false,
        name: CALL_TYPE_CAMPAIGN_NAME.ALL_CALLS,
    },
    {
        value: true,
        name: CALL_TYPE_CAMPAIGN_NAME.INBOUND_ONLY
    }
]

export const MODE = {
    CREATE: 'create',
    EDIT: 'edit'
}

export const optionGroupType = [
    {
        label: 'Insurance Type',
        options: [{ label: 'All', value: '' }, ...INTEGRATION_LEAD_TYPES.map(element => ({ label: capitalizeWord(element.name), value: element.name }))],
    },
];

export const optionGroupTypeForCalls = [
    {
        label: 'Insurance Type',
        options: [{ label: 'All', value: '' }, ...LEAD_TYPES.map(element => ({ label: capitalizeWord(element.name), value: element.name }))],
    },
];


export const optionGroupProduct = (() => {
    switch (AppConfiguration.PRODUCT_NAME) {
        case WHITE_LABELED_PRODUCT_NAMES.GOAL:
            return [
                {
                    label: 'Product',
                    options: [
                        { label: 'All', value: '' },
                        { label: 'Quote Funnels', value: 'quote funnels' },
                    ],
                },
            ];
        case WHITE_LABELED_PRODUCT_NAMES.BENEPATH:
            return [
                {
                    label: 'Product',
                    options: [
                        { label: 'All', value: '' },
                        { label: 'Clicks', value: 'clicks' },
                        { label: 'Leads', value: 'leads' },
                        { label: 'Calls', value: 'calls' },
                    ],
                },
            ];
        default:
            return [
                {
                    label: 'Product',
                    options: [
                        { label: 'All', value: '' },
                        { label: 'Clicks', value: 'clicks' },
                        { label: 'Leads', value: 'leads' },
                        { label: 'Calls', value: 'calls' },
                        { label: 'Syndi Clicks', value: 'syndi clicks' },
                    ],
                },
            ];
    }
})();

export const ACCOUNT_OWNER = "Account Owner"
export const USER_TYPES = { ADMIN: "admin", SUPER_ADMIN: "super admin" }
export const TEMPLATE_TYPES = { SUPER_TEMPLATE: "Super Template" }

export const MONTH_NAMES = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export const OPTIONS_TIMEZONE = [
    { label: 'Pacific Time (PT)', value: 'America/Los_Angeles' },
    { label: 'Eastern Time (ET)', value: 'America/New_York' },
    { label: 'Central Time (CT)', value: 'America/Chicago' },
    { label: 'Mountain Time (MT)', value: 'America/Denver' },
    { label: 'Alaska Time (AST)', value: 'America/Juneau' },
    { label: 'Hawaii Time (HST)', value: 'Pacific/Honolulu' },
];
export const OPTIONS_TIMEZONE_W_UTC = [
    ...OPTIONS_TIMEZONE,
    { label: 'Coordinated Universal Time (UTC)', value: 'Etc/UTC' },
]

export const TIMEZONE_NAMES = {
    PACIFIC_TIME: 'Pacific Time (PT)',
    EASTERN_TIME: 'Eastern Time (ET)',
    CENTRAL_TIME: 'Central Time (CT)',
    MOUNTAIN_TIME: 'Mountain Time (MT)',
    ALASKA_TIME: 'Alaska Time (AST)',
    HAWAII_TIME: 'Hawaii Time (HST)',
    LOCAL_TIME: 'Local',
}

export const REPORTING_TIMEZONE = 'America/Los_Angeles';
export const UTC_TIMEZONE = 'UTC'

export const MARITAL_STATUS_OPT_1_2 = {
    1: { label: "Single", value: "1" },
    2: { label: "Married", value: "2" },
}

export const ADMIN_CLIENTS_FILTER_CATEGORIES = {
    CONTACT: 'Contact',
    ACCOUNT: 'Account',
    ACCOUNT_SETTINGS: 'Account Settings',
    CARRIER: 'Carrier',
    PRODUCT: 'Product',
    BILLING: 'Billing',
}

export const SALES_MANAGER_OPTIONS = {
    SALES_REP: "sales rep",
    NATIONAL_SALES_MANAGER: "national sales manager",
    SALES_MANAGER: "sales manager"
}

export const ACCOUNT_MANAGER_OPTIONS = {
    ACCOUNT_MANAGER: "account manager",
    ADMIN_ROLE: "admin"
}

export const FILTERED_COLUMNS_OBJECTS = {
    ACCOUNT_NUMBER: { name: 'Account Number', fieldName: 'account_number' },
    ACCOUNT_CREATION: { name: 'Account Creation', fieldName: 'created_at' },
    ACCOUNT_MANAGER: { name: 'Account Manager', fieldName: 'account_manager' },
    FIRST_NAME: { name: 'First Name', fieldName: 'first_name' },
    LAST_NAME: { name: 'Last Name', fieldName: 'last_name' },
    CITY: { name: 'City', fieldName: 'city' },
    STATE: { name: 'State', fieldName: 'state' },
    ZIP_CODE: { name: 'Zip Code', fieldName: 'zip_code' },
    EMAIL: { name: 'Email', fieldName: 'email' },
    PHONE: { name: 'Phone', fieldName: 'phone_num' },
    SALES_REP: { name: 'Sales Rep', fieldName: 'sales_manager' },
    BUSINESS_NAME: { name: 'Company Name', fieldName: 'company_name' },
    REBILL: { name: 'Rebill', fieldName: 'rebill' },
    REBILL_AMOUNT: { name: 'Rebill Amount', fieldName: 'rebill_amount' },
    REBILL_FAILURE: { name: 'Rebill Failure', fieldName: 'rebill_failure' },
    INVOICE: { name: 'Invoice', fieldName: 'invoice' },
    CARRIER: { name: 'Carrier', fieldName: 'carrier' },
    STATUS: { name: 'Status', fieldName: 'status' },
    ADDRESS: { name: 'Address', fieldName: 'address' },
    TIMEZONE: { name: 'Timezone', fieldName: 'timezone' },
    INTERNAL: { name: "Internal", fieldName: 'internal' },
    ENTERPRISE: { name: "Enterprise", fieldName: 'enterprise' },
    IS_MFA_ENABLED: { name: 'Is MFA Enabled', fieldName: 'is_mfa_enabled' },
    ACTIVATION_TIME: { name: 'Activation Time', fieldName: 'activation_time' },
    PRODUCTS: { name: 'Products', fieldName: 'distinct_product_types' },
    CREADIT_LIMIT: { name: 'Credit Limit', fieldName: 'credit_limit' },
    CURRENT_BALANCE: { name: 'Current Balance', fieldName: 'current_balance' },
    PROMO_BALANCE: { name: 'Promo Balance', fieldName: 'promo_balance' },
    TOTAL_BALANCE: { name: 'Total Balance', fieldName: 'total_balance' },
    ACCOUNT_PACE: { name: 'Pace', fieldName: 'account_pace' },
    TOTAL_SPEND: { name: 'Total Spend', fieldName: 'total_spend' },
    TOTAL_CAMPAIGNS: { name: 'Total Campaigns', fieldName: 'total_campaigns' },
    CALL_TRANSCRIPTION: { name: 'Call Transcription Enabled', fieldName: 'call_transcription' },
    POST_URL: { name: 'Post URL', fieldName: 'post_url' },
    TEST: { name: 'Test', fieldName: 'test' },
    CAMPAIGN_IDS: { name: 'Campaign', fieldName: 'campaign_ids' },
    IVR: { name: 'IVR', fieldName: 'ivr' },
    BILLABLE_DURATION: { name: 'Billable Duration', fieldName: 'billable_duration' },
    CUSTOMER_CALLER_ID: { name: 'Customer Caller ID', fieldName: 'show_customer_caller_id' },
    DATA_RELEASE_DURATION: { name: 'Data Release Duration', fieldName: 'data_release_duration' },
    DISTRIBUTION_SETTINGS: { name: 'Distribution Settings', fieldName: 'overflow' },
    CONCURRENCY: { name: 'Concurrency', fieldName: 'concurrency_cap' },
    TRANSFER_TYPE: { name: 'Transfer Type', fieldName: 'transfer_type' },
    CALL_ORIGINATION_TYPE: { name: 'Call Origination Type', fieldName: 'call_origination_type' },
    ALLOWABLE_RETURN_PERCENTAGE: { name: 'Allowable Return Percentage', fieldName: 'allowable_return_perc' },
    THROTTLE: { name: 'Throttle', fieldName: 'throttle' },
    COMPANY_NAME_OR_ACCOUNT_ID: { name: 'Company Name or Account ID', fieldName: 'company_name_or_account_id' }
}

export const INTERNAL_USERS_FILTERED_COLUMNS_OBJECTS = {
    USER_ID: { name: 'User Id', fieldName: 'user_id' },
    STATUS: { name: 'Status', fieldName: 'status' },
    FIRST_NAME: { name: 'First Name', fieldName: 'first_name' },
    LAST_NAME: { name: 'Last Name', fieldName: 'last_name' },
    EMAIL: { name: 'Email', fieldName: 'email' },
    ROLE: { name: 'Role', fieldName: 'role' },
    DEPARTMENT: { name: 'Department', fieldName: 'department' },
    LAST_SIGN_IN_AT: { name: 'Last Sign-in at', fieldName: 'last_sign_in_at' },
    SIGN_IN_COUNT: { name: 'Sign-in count', fieldName: 'sign_in_count' },
    USERNAME: { name: "Username", fieldName: 'username' }
}

export const LEADS_FILTERED_COLUMNS_OBJECTS = {
    FIRST_NAME: { name: 'First Name', fieldName: 'first_name' },
    LAST_NAME: { name: 'Last Name', fieldName: 'last_name' },
    STATE: { name: 'State', fieldName: 'state' },
    EMAIL: { name: 'Email', fieldName: 'email' },
    PHONE: { name: 'Phone', fieldName: 'phone_num' },
    CAMPAIGN_NAME: { name: 'Campaign Name', fieldName: 'campaign_name' },
    LEAD_TYPE: { name: 'Type', fieldName: 'lead_type' },
    STATUS: { name: 'Disposition', fieldName: 'status' },
    RECEIVED: { name: 'Received', fieldName: 'received' },
    BRAND_NAME: { name: 'Brands', fieldName: 'brand_name' }
}

export const BILLING_EVENTS_FILTERED_COLUMNS_OBJECTS = {
    EVENT_TYPE: { fieldName: 'event_type', name: 'Event Type' },
    STRIPE_EVENT_ID: { fieldName: 'stripe_event_id', name: 'Stripe Event ID' },
    AMOUNT: { fieldName: 'amount', name: 'Amount' },
    STATUS: { fieldName: 'status', name: 'Status' },
    CREATED_AT: { fieldName: 'created_at', name: 'Created At' },
    COMPANY_NAME: { fieldName: 'company_name', name: 'Company Name' },
    ACCOUNT_ID: { fieldName: 'account_id', name: 'Account ID' }
}

export const WHITELABELED_BRANDS_FILTERED_COLUMNS_OBJECTS = {
    NAME: { name: 'Name', fieldName: 'name' },
    STATUS: { name: 'Status', fieldName: 'status' },
    ID: { name: 'ID', fieldName: 'id' },
    EMAIL: { name: 'Email', fieldName: 'email' },
    BRAND: { name: 'Brand', fieldName: 'brand' },
}

export const CAMPAIGN_ANALYSIS_FILTERED_COLUMNS_OBJECTS = {
    BRAND: { name: 'Brand', fieldName: 'brand' },
    CAMPAIGN: { name: 'Campaign', fieldName: 'campaign' },
    QUALIFIED: { name: 'Qualified', fieldName: 'qualified' },
    WON: { name: 'Won', fieldName: 'won' },
    DISQUALIFIED_CAUSE: { name: 'Disqualification Cause', fieldName: 'disqualif' },
    TIME_RANGE: { name: 'Time Range', fieldName: 'time_range' },
    SOURCE_TYPE: { name: 'Source Type', fieldName: 'source_type' }
}

export const RECEIPT_LOGS_FILTERED_COLUMNS_OBJECTS = {
    CREATED_AT: { name: 'Created At', fieldName: 'created_at' },
    ADMIN_USER: { name: 'Admin User', fieldName: 'admin_user' },
    TRANSACTION_TYPE: { name: 'Transaction Type', fieldName: 'transaction_type' },
    COMPANY_NAME: { name: 'Company Name', fieldName: 'company_name' },
    BRAND: { name: 'Brand', fieldName: 'brand' },
    RECEIPT_TYPE: { name: 'Receipt Type', fieldName: 'receipt_type' },
    ACCOUNT_ID: { name: 'Account ID', fieldName: 'account_id' },
    AMOUNT: { name: 'Amount', fieldName: 'amount' },
    CURRENT_BALANCE: { name: 'Current Balance', fieldName: 'current_balance' },
    PROMO_BALANCE: { name: 'Promo Balance', fieldName: 'promo_balance' },
    SELECTED_ACCOUNT: { name: 'Selected Account', fieldName: 'selected_account' },
    IP: { name: 'IP Address', fieldName: 'ip_address' }
}
export const CALLS_FILTERED_COLUMNS_OBJECTS = {
    FIRST_NAME: { name: 'First Name', fieldName: 'first_name' },
    LAST_NAME: { name: 'Last Name', fieldName: 'last_name' },
    STATE: { name: 'State', fieldName: 'state' },
    PHONE: { name: 'Phone', fieldName: 'phone_num' },
    RECEIVED: { name: 'Received', fieldName: 'received' },
    CALL_DURATION: { name: 'Call Duration', fieldName: 'call_duration' },
    INSURED: { name: 'Insured', fieldName: 'insured' },
    ZIP_CODE: { name: 'Zip Code', fieldName: 'zip_code' },
    ADDRESS: { name: 'Address', fieldName: 'address' },
    CITY: { name: 'City', fieldName: 'city' },
    DRIVERS: { name: 'Applicants', fieldName: 'drivers' },
    VEHICLES: { name: 'Vehicles', fieldName: 'vehicles' },
    LEAD_TYPE: { name: 'Type', fieldName: 'lead_type' },
    STATUS: { name: 'Status', fieldName: 'status' },
    CAMPAIGN_NAME: { name: 'Campaign Name', fieldName: 'campaign_name' },
    DISPOSITION: { name: 'Disposition', fieldName: 'disposition' },
    BILLABLE: { name: 'Billable', fieldName: 'billable' },
    BRAND_NAME: { name: 'Brand Name', fieldName: 'brand_name' },
}

export const USER_ACTIVITY_COLUMNS_OBJECTS = {
    USER_ID: { name: 'User ID', fieldName: 'user_id' },
    ACCOUNT_ID: { name: 'Account ID', fieldName: 'account_id' },
    VISIT_TOKEN: { name: 'Visit Token', fieldName: 'visit_token' },
    VISITOR_TOKEN: { name: 'Visitor Token', fieldName: 'visitor_token' },
    IP: { name: 'IP', fieldName: 'ip' },
    USER_AGENT: { name: 'User Agent', fieldName: 'user_agent' },
    REFERRER: { name: 'Referrer', fieldName: 'referrer' },
    REFERRING_DOMAIN: { name: 'Referring Domain', fieldName: 'referring_domain' },
    LANDING_PAGE: { name: 'Landing Page', fieldName: 'landing_page' },
    BROWSER: { name: 'Browser', fieldName: 'browser' },
    OS: { name: 'OS', fieldName: 'os' },
    DEVICE_TYPE: { name: 'Device Type', fieldName: 'device_type' },
    COUNTRY: { name: 'Country', fieldName: 'country' },
    REGION: { name: 'Region', fieldName: 'region' },
    CITY: { name: 'City', fieldName: 'city' },
    LATITUDE: { name: 'Latitude', fieldName: 'latitude' },
    LONGITUDE: { name: 'Longitude', fieldName: 'longitude' },
    UTM_SOURCE: { name: 'UTM Source', fieldName: 'utm_source' },
    UTM_MEDIUM: { name: 'UTM Medium', fieldName: 'utm_medium' },
    UTM_TERM: { name: 'UTM Term', fieldName: 'utm_term' },
    UTM_CONTENT: { name: 'UTM Content', fieldName: 'utm_content' },
    UTM_CAMPAIGN: { name: 'UTM Campaign', fieldName: 'utm_campaign' },
    APP_VERSION: { name: 'App Version', fieldName: 'app_version' },
    OS_VERSION: { name: 'OS Version', fieldName: 'os_version' },
    PLATFORM: { name: 'Platform', fieldName: 'platform' },
    STARTED_AT: { name: 'Time', fieldName: 'started_at' },
    COMPANY_NAME: { name: 'Company Name', fieldName: 'company_name' },
}

export const EMAIL_EVENT_FILTERED_COLUMNS_OBJECTS = {
    ACCOUNT_NUMBER: { name: 'Account ID', fieldName: 'account_number' },
    EMAIL: { name: 'Email', fieldName: 'email' },
    ACCOUNT_CREATION: { name: 'Event Created At', fieldName: 'created_at' },
    EVENT: { name: 'Event', fieldName: 'event' },
    CATEGORY: { name: 'Category', fieldName: 'category' },
}

export const ACCOUNT_NUMBER_OPTIONS_SYMBOL = {
    GREATER_THAN: 'Greater Than',
    LESS_THAN: 'Less Than',
    EQUAL_TO: 'Equal To',
    UNLIMITED: 'Unlimited'
}

export const yesNoOptionsWithIntValues = [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
]

export const YesNoOptionsWithBooleanValues = [
    { label: "Yes", value: true },
    { label: "No", value: false }
]

export const operatingSystemOptions = [
    { label: "Windows OS", value: "windows" },
    { label: "mac OS", value: "mac" },
    { label: "Linux OS", value: "linux" },
    { label: "Android OS", value: "android" },
    { label: "iOS", value: "ios" },
    { label: "Chrome OS", value: "chrome" },
    { label: "CentOS", value: "centos" }
]

export const browserSystemOptions = [{ label: "Google Chrome", value: "chrome" },
{ label: "Mozilla Firefox", value: "firefox" },
{ label: "Apple Safari", value: "safari" },
{ label: "Microsoft Edge", value: "microsoft edge" },
{ label: "Opera", value: "opera" },
{ label: "Brave", value: "brave" },
{ label: "Vivaldi", value: "vivaldi" },
{ label: "Internet Explorer", value: "internet explorer" },]

export const deviceTypeOptions = [
    { label: "Desktop", value: "desktop" },
    { label: "Laptop", value: "laptop" },
    { label: "Mobile", value: "mobile" },
    { label: "Tablet", value: "tablet" },
    { label: "Other", value: "other" }
]

export const ADMIN_TWILIO_NUMBERS_OPTIONS = {
    ACCOUNT_ID: { name: 'Account ID', fieldName: 'account_number' },
    PHONE_NUMBER: { name: 'Phone Number', fieldName: 'phone_number' },
    CAMPAIGN_NAME: { name: 'Campaign Name', fieldName: 'campaign_name' },
    COMPNAY_NAME: { name: 'Company Name', fieldName: 'company_name' },
    CREATED_AT: { name: 'Created At', fieldName: 'created_at' },
    RELEASED_AT: { name: 'Released At', fieldName: 'released_at' },
}

export const ADMIN_LEAD_REFUNDS_OPTIONS = {
    ACCOUNT_ID: { name: 'Account ID', fieldName: 'account_number' },
    STATUS: { name: 'Status', fieldName: 'status' },
    PHONE_NUMBER: { name: 'Phone Number', fieldName: 'phone_number' },
    EMAIL: { name: 'Email', fieldName: 'email' },
    LEAD_TYPE: { name: 'Lead Type', fieldName: 'lead_type' },
    CAMPAIGN_NAME: { name: 'Campaign Name', fieldName: 'campaign_name' },
    COMPNAY_NAME: { name: 'Company Name', fieldName: 'company_name' },
    CREATED_AT: { name: 'Created At', fieldName: 'created_at' },
}

export const ADMIN_FEATURE_IDS = {
    MANAGE_ADMIN_USERS: 1,
    MANAGE_CLIENT_USERS: 2,
    MANAGE_ASSIGNED_ADMIN_USERS: 3,
    MANAGE_ASSIGNED_CLIENT_USERS: 4,
    MANAGE_ADMIN_ROLES: 5,
    VIEW_CLIENT_USERS: 6,
    VIEW_ASSIGNED_CLIENT_USERS: 7,
    VIEW_ADMIN_USERS: 8,
    VIEW_ASSIGNED_ADMIN_USERS: 9,
    MANAGE_FEATURE_FLAGS: 10,
    MANAGE_ACCOUNTING: 11,
    MANAGE_NOTIFICATION_TEMPLATES: 12,
    SIGN_IN_TO_ASSIGNED_ADMIN_USERS: 14,
    VIEW_EMAIL_ACTIVITY: 15,
    VIEW_USER_ACTIVITY: 16,
    VIEW_CHANGE_HISTORY: 17,
    MANAGE_INSURANCE_CARRIERS: 18,
    MANAGE_REFUND_REASONS: 19,
    ACCESS_WHITELISTED_BRANDS: 20,
    MANAGE_WHITELISTED_BRANDS: 21,
    MANAGE_SF_FILTERS: 22,
    MANAGE_FILTER_PACKAGES: 23,
    MANAGE_WHITELISTED_BRANDS_FEATURE_FLAGS: 24,
    MANAGE_PLATFORM_SETTINGS: 25,
    MANAGE_BUDGETS: 26,
    VIEW_DEV_DASHBOARD: 28,
}



// For ScheduleReport

export const allowedPeriodsArray = ['month', 'week', 'day']

export const ALLOWED_DROPDOWN_OPTIONS = {
    PERIOD: 'period',
    MONTHS: 'months',
    MONTH_DAYS: 'month-days',
    WEEK_DAYS: 'week-days'
}

export const AM = 'am';
export const PM = 'pm';
export const AM_PM_OPTIONS = [
    { label: AM, value: AM },
    { label: PM, value: PM }
]

export const HOUR_OPTIONS = [
    { label: '01', value: 1 },
    { label: '02', value: 2 },
    { label: '03', value: 3 },
    { label: '04', value: 4 },
    { label: '05', value: 5 },
    { label: '06', value: 6 },
    { label: '07', value: 7 },
    { label: '08', value: 8 },
    { label: '09', value: 9 },
    { label: '10', value: 10 },
    { label: '11', value: 11 },
    { label: '12', value: 12 },
]

export const REPORT_FORMAT = {
    TABLE_BODY: "email_table_body",
    AWS_BODY: "s3_url",
    CSV: "csv",
    ZIPPED_CSV: "zipped_csv",
}

export const SCHEDULE_REPORT_DELIVERY_TYPE = {
    EMAIL: "email",
    SFTP: "sftp"
}

export const SFTP_LOGIN_TYPE = {
    PASSWORD: "password",
    KEY: "key"
}

export const ADCREATIVE_FILE_SIZE_LIMIT_IN_BYTES = 450000;
export const ADCREATIVE_IMAGE_DIMENSION_WIDTH = 496;
export const ADCREATIVE_IMAGE_DIMENSION_HEIGHT = 240;
export const AGENT_PROFILE_IMG_DIMENSION_WIDTH = 300
export const AGENT_PROFILE_IMG_DIMENSION_HEIGHT = 300

export const STATE_STR = "State";

export const TRANSACTION_TYPE = {
    CREDIT: "Credit",
    DEBIT: "Debit"
}

export const transactionType = [
    { name: TRANSACTION_TYPE.CREDIT, id: 0 },
    { name: TRANSACTION_TYPE.DEBIT, id: 1 },
]

export const transactiontypeOptions = transactionType.map(single_object => ({ label: single_object.name, value: single_object.id }));
export const PERMISSION_TYPES = {
    CREATE: 'can_create',
    READ: 'can_read',
    UPDATE: 'can_update',
    DELETE: 'can_delete'
}

export const HTML_SNIPPET_TYPE = {
    IFRAME: "iframe",
    IMAGE: "image"
}

let E_DESCRIPTION =
    <div>
        <p>Event mode</p>
        <p>It can be either 1 (new record, also the default), 0 (overwrite existing if any) or 2 (add to and overwrite existing).</p>
        <p>Event mode of 1 means we create a new record/conversion with all the data. Event mode of 0 means we overwrite the existing record if any. If there is no existing record, we create a new record. Event mode of 2 means we add to the existing event and overwrite it, if the record doesn't exist, we create a new record.</p>
    </div>

export const API_INSTRUCTIONS_TABLE_DATA = [
    { parameter: "p_id", description: "The pixel id associated with the conversion.", required: "Yes" },
    { parameter: "click_id", description: "The click id associated with the conversion", required: "Yes" },
    { parameter: "lead_id", description: "The lead id associated with the conversion", required: "Yes" },
    { parameter: "caller_id", description: "The caller_id associated with the conversion", required: "Yes" },
    { parameter: "e", description: E_DESCRIPTION, required: "Yes" },
    { parameter: "rev", description: "Revenue", required: "No" }
]


export const EVENT_MODE_OVERWRITE_IF_EXISTING_OR_NEW = '0'
export const EVENT_MODE_NEW_RECORD = '1'
export const EVENT_MODE_ADD_REVENUE_AND_OVERWRITE = '2'

export const CREATIVE_PAGE_TABLE_DATA = [
    { name: "{state}", description: "Complete State name" },
    { name: "{state_code}", description: "2 Letter State Code" },
    { name: "{zip}", description: "5 Digit zip code" },
    { name: "{city}", description: "City" },
    { name: "{county}", description: "County" },
    { name: "{address}", description: "Address (if available)" },
    { name: "{first_name}", description: "First name (if available)" },
    { name: "{last_name}", description: "Last name (if available)" },
    { name: "{email}", description: "Email (if available)" },
    { name: "{phone}", description: "Phone (if available)" },
    { name: "{dob}", description: "Date of birth (if available)" },
    { name: "{source_type}", description: "Lead Source Type" },
    { name: "{source_type_id}", description: "Lead Source Type ID" },
    { name: "{click_id}", description: "Click ID" },
    { name: "{d1gender}", description: "Primary Driver Gender" },
    { name: "{AdGroupName}", description: "Name of the ad group" },
    { name: "{adcreativename}", description: "Creative/Ad name for the ad being served" },
]

export const POPUP_MESSAGE_MACROS = [
    { name: "{first_name}", description: "First name" },
    { name: "{last_name}", description: "Last name" },
    { name: "{vehicle_year}", description: "Vehicle Year" },
    { name: "{vehicle_make}", description: "Vehicle Make" },
    { name: "{vehicle_model}", description: "Vehicle Model" }
]

export const PIXEL_COLUMN_TABLE_FIELDS = {
    DISP_COUNT: "disp_count",
    DISP_CVR: "disp_cvr",
    DISP_CPA: "disp_cpa",
    DISP_REV: "disp_rev",
    DISP_REV_PER_PIXEL: "disp_rev_per_pixel",
    DISP_ROAS: "disp_roas",
    DISP_CLICKS_COUNT: "disp_clicks_count",
    DISP_CLICKS_CVR: "disp_clicks_cvr",
    DISP_CLICKS_CPA: "disp_clicks_cpa",
    DISP_CLICKS_REV: "disp_clicks_rev",
    DISP_CLICKS_ROAS: "disp_clicks_roas",
    DISP_LEADS_COUNT: "disp_leads_count",
    DISP_LEADS_CVR: "disp_leads_cvr",
    DISP_LEADS_CPA: "disp_leads_cpa",
    DISP_LEADS_REV: "disp_leads_rev",
    DISP_LEADS_REV_PER_PIXEL: "disp_leads_rev_per_pixel",
    DISP_LEADS_ROAS: "disp_leads_roas",
    DISP_CALLS_COUNT: "disp_calls_count",
    DISP_CALLS_CVR: "disp_calls_cvr",
    DISP_CALLS_CPA: "disp_calls_cpa",
    DISP_CALLS_REV: "disp_calls_rev",
    DISP_CALLS_REV_PER_PIXEL: "disp_calls_rev_per_pixel",
    DISP_CALLS_ROAS: "disp_calls_roas"
}

export const PIXEL_COLUMN_TABLE_BY_PRODUCT_FIELDS = {
    "clicks": {
        DISP_COUNT: "disp_count",
        DISP_CVR: "disp_cvr",
        DISP_CPA: "disp_cpa",
        DISP_REV: "disp_rev",
        DISP_REV_PER_PIXEL: "disp_rev_per_pixel",
        DISP_ROAS: "disp_roas",
        DISP_INDIVIDUAL_CLICK_COUNT: "disp_individual_clicks_count",
        DISP_INDIVIDUAL_CLICK_REV: "disp_individual_clicks_rev",
    },
    "leads": {
        DISP_COUNT: "disp_leads_count",
        DISP_CVR: "disp_leads_cvr",
        DISP_CPA: "disp_leads_cpa",
        DISP_REV: "disp_leads_rev",
        DISP_REV_PER_PIXEL: "disp_leads_rev_per_pixel",
        DISP_ROAS: "disp_leads_roas",
    },
    "calls": {
        DISP_COUNT: "disp_calls_count",
        DISP_CVR: "disp_calls_cvr",
        DISP_CPA: "disp_calls_cpa",
        DISP_REV: "disp_calls_rev",
        DISP_REV_PER_PIXEL: "disp_calls_rev_per_pixel",
        DISP_ROAS: "disp_calls_roas",
    },
    "quote funnels": {
        DISP_COUNT: "disp_count",
        DISP_CVR: "disp_cvr",
        DISP_CPA: "disp_cpa",
        DISP_REV: "disp_rev",
        DISP_REV_PER_PIXEL: "disp_rev_per_pixel",
        DISP_ROAS: "disp_roas",
    },
    "syndi clicks": {
        DISP_COUNT: "disp_count",
        DISP_CVR: "disp_cvr",
        DISP_CPA: "disp_cpa",
        DISP_REV: "disp_rev",
        DISP_REV_PER_PIXEL: "disp_rev_per_pixel",
        DISP_ROAS: "disp_roas",
    },
}

export const CONVERSION_LOGS_PIXEL_COLUMN_FIELDS = {
    DISP_NEW: "disp_new",
    DISP_UPDATED: "disp_updated",
    DISP_INVALID: "disp_invalid",
}

export const GENDER = {
    MALE: "male",
    FEMALE: "female"
}

export const YES_AND_NO = {
    YES: "yes",
    NO: "no"
}

export const TRUE_AND_FALSE = {
    TRUE: true,
    FALSE: false
}

export const REQUIRED_FEATURE_FLAGS = {
    FRONTEND_SHOW_NUM_QUERIES: "frontend::show_num_queries::Show number of queries in Ad groups and Source Settings Pages",
    FRONTEND_INDIVIDUAL_CLICKS_SMART_VIEW: "frontend::show_individual_clicks::Show Smart Views on Analytics page which return individual click listings",
    BOTH_PAYMENT_TERMS: "both::payment_terms::Generate Invoices based on payment terms",
    CLIENT_RESEND_INVITE: "frontend::client_resend_invite::Show option to resend invite in Clients User Management page",
    CLIENT_SHOW_SIGN_IN_COUNT_LAST_SIGN_IN: "frontend::client_show_sign_in_count_last_sign_in::Show sign-in count and last sign in at in Client-side User Management",
    ADMIN_SHOW_SIGN_IN_COUNT_LAST_SIGN_IN: "frontend::show_sign_in_count_last_sign_in::Show sign-in count and last sign in at in User Management",
    ADMIN_SHOW_DELETED_USERS: "frontend::admin_show_deleted_users::Show deleted admin users in user management",
    both_copy_bid_modifiers_and_filters: 'both::copy_bid_modifiers_and_filters::Copy bid modifiers and filters to other selected campaigns',
    BOTH_FEATURE_FLAG_CARRIER_ID: 'both::carrier_id::Add Carrier id to accounts',
    SF_FEATURE_FLAG_RECEIPT_PAGINATION: 'both::receipt_pagination::Set pagination for receipts',
    ADMIN_SPECIFIC_SETTINGS_CAMPAIGN: 'frontend::admin_specific_settings_campaign::Show settings only available to admins in Edit Campaign page',
    CAMPAIGN_CREATIVES_SEARCHES_IMPRESSIONS: 'frontend::campaign_creatives_searches_impressions::Searches and impressions for All campaigns and All creatives page',
    ADD_DELAY_BETWEEN_APIS_DASHBOARD: 'frontend::add_delay_between_apis_dashboard::Add delay between API calls on dashboard. Experimental for API optimization',
    ADMIN_SPECIFIC_SETTINGS_LEAD_INTEGRATION: 'frontend::admin_specific_settings_lead_integrations::Show admin settings only available to admins in lead integrations page',
    SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE: 'both::user_column_preference::Enable the feature to customize the column preferences for campaigns, adgroups and source settings page',
    SF_FEATURE_FLAG_CLIENT_ACCOUNT_SETTINGS: 'frontend::client_account_settings::Show client account settings when logged in as admin',
    SF_EXPORT_DATA_FROM_BACKEND: 'frontend::export_data_from_backend::Enable the export data logic from backend',
    SF_FEATURE_FLAG_ADDSCREENCAST: 'frontend::view_feature_screencast::View Screencast for a feature flag if available',
    SF_FEATURE_FLAG_ADMIN_USERS_PAGE_FILTERS: 'frontend::admin_users_page_filters::Enable filters option in admin user management page',
    SF_FEATURE_FLAG_SHOW_ALL_CLIENTS_PAGE: 'both::show_all_client_users_page::Show all users in clients page instead of just Account Owners',
    SF_FEATURE_CALLS_LEADS: 'both::calls_leads_ui::Enable calls and leads product types and their UI components',
    SF_FEATURE_FLAG_ADMIN_SETTINGS_FILTERS_ON_ADMIN_CLIENTS_PAGE: 'both::admin_settings_filters_on_admin_clients_page::Show Admin settings filters on admin clients page',
    SF_FEATURE_FLAG_CAMPAIGN_PACE: 'both::campaign_pace::Display campaign pace',
    SF_FEATURE_FLAG_GET_ACCOUNT_PACE: 'both::enable_get_account_pace::Enable get account pace',
    SF_FEATURE_FLAG_SHOW_PII_AND_FULL_DATA_COLUMNS: 'both::show_pii_and_full_data_columns::Show PII and Full data columns',
    SF_FEATURE_FLAG_SHOW_REBILL_FAILURE_NOTIFICATION: 'both::show_rebill_failure_notification::Show rebill failure notification',

    SF_FEATURE_FLAG_SHOW_API_TOKENS: 'frontend::show_api_tokens::API Tokens section in settings page',
    SF_FEATURE_FLAG_CAMPAIGN_SUMMARY_API_OPTIMIZATION: 'frontend::campaign_summary_api_optimization::API optimization for campaign summary page',
    SF_FEATURE_FLAG_SHOW_SCHEDULE_MACROS: 'frontend::show_schedule_macros::View Schedule macros description in Schedule Macros',
    SF_FEATURE_FLAG_SHOW_VOLUME_FORECAST: 'frontend::show_volume_forecast::View volume forecast in Campaign filters',
    SF_FEATURE_FLAG_SHOW_PAY_INVOICE_PAGE: 'both::show_pay_invoice_page::Pay Invoice page in Accounting section',
    SF_FEATURE_FLAG_ACCOUNT_NOTIFICATIONS: 'both::account_notifications::Send email notifications based on preferences on account events',
    SF_FEATURE_FLAG_SCHEDULED_REPORT_LOGS: 'frontend::show_scheduled_report_logs::Show option to View logs for a scheduled report in Existing Scheduled Reports page',
    SF_FEATURE_FLAG_SHOW_PIXEL_DATA_TOGGLE_IN_SCHEDULED_REPORT: 'frontend::show_pixel_data_toggle_in_scheduled_report::Show pixel/conversion data toggle in the schedule report modal (admins only)',
    SF_FEATURE_FLAG_ANALYTICS_CLICK_COLUMNS_INSURANCE_TYPE: 'frontend::show_analytics_additional_click_columns::Show additional columns in analytics clicks based on insurance types selected',
    SF_FEATURE_FLAG_SHOW_CLICK_CONVERSION_CSV_IMPORT: 'frontend::show_click_conversion_csv_import::Show button for showing click conversion csv file import',
    SF_FEATURE_FLAG_FEATURE_FLAG_EXTENSIONS: 'frontend::feature_flag_extensions::Enable a feature flag to be enabled/disabled at account and admin user level',
    SF_FEATURE_FLAG_SHOW_PIXEL_STATS_FOR_CAMPAIGNS: 'frontend::show_pixel_stats_for_campaigns::Show pixel stats for campaigns',
    SF_FEATURE_FLAG_CAMPAIGN_API_SPLIT: 'both::split_campaign_apis::Split ad groups and source settings APIs',
    SF_FEATURE_FLAG_RTB_BID_MULTIPLIER_HISTORY: 'both::rtb_bid_multiplier_history::Show bid multiplier change-history clock icon and popup on the RTB sources page',
    SF_FEATURE_FLAG_SHOW_RECEIPT_IN_ADMIN_PORTAL: "both::show_receipt_in_admin_portal::Show receipt in admin portal",
    SF_FEATURE_FLAG_AD_GROUP_VOLUME_FORECAST: "frontend::show_ad_group_filters_volume_forecast::View volume forecast in Adgroup filters",
    SF_FEATURE_FLAG_PROFILE_VOLUME_FORECAST: "frontend::show_profiles_filters_volume_forecast::View volume forecast in Profile filters",
    SF_FEATURE_FLAG_LEADS_CALLS_CAMPAIGNS_ADMIN_SETTINGS: "frontend::show_leads_and_calls_campaign_admin_settings::Admin can change settings of leads and calls campaigns",
    SF_FEATURE_FLAG_DASHBOARD_FOR_LEADS_AND_CALLS: "frontend::dashbaord_for_leads_and_calls::View Dashboard for Leads and Calls",
    SF_FEATURE_FLAG_EXPORT_ANALYTICS_EMAIL: "frontend::analytics_clicks_export_email::Send email on analytics export when clicks smart view is selected",
    SF_FEATURE_INTEGRATIONS_INDEX_AND_WORKFLOW: "frontend::integrations_index_and_creation_workflow::Show integration index page and creation workflow",
    SF_FEATURE_FLAG_SHOW_EMAIL_EVENTS: "frontend::show_email_events::Show email events for all emails sent to users",
    SF_FEATURE_ENABLE_CACHE: "frontend::enable_cache_for_campaign_and_creative::Enable cache to avoid page reloading for campaigns and creatives page",
    SF_FEATURE_FLAG_ENABLE_ACCOUNT_VISITORS: 'both::enable_account_visitors::Show account visitors for an account',
    SF_FEATURE_FLAG_RETAIL_CAMPAIGN_PAUSABLE: 'both::pausable_lead_call_campaigns::Pausable lead or call campaigns for retail users',
    SF_FEATURE_FLAG_ALLOW_DROPDOWN_CLOSE: 'frontend::enable_closing_of_dropdowns::Close dropdown on clicking outside',
    SF_FEATURE_FLAG_SHOW_LEAD_TYPE_DROPDOWN: 'frontend::show_lead_type_dropdowns::Lead Type Dropdown For Formatters in Lead Integration',
    SF_FEATURE_FLAG_SHOW_LEADS_CALLS_IN_SIDEBAR: 'frontend::show_leads_and_calls_option_in_sidebar::Show Leads and Calls option in the sidenav',
    SF_FEATURE_FLAG_SHOW_CPA_OPTIMIZER: 'frontend::show_cpa_optimizer::Show CPA Optimizer',
    SF_FEATURE_FLAG_FRONTEND_INDIVIDUAL_CALLS_SMART_VIEW: 'frontend::show_individual_calls::Show Smart Views on Analytics page which return individual call listings',
    SF_FEATURE_FLAG_SHOW_SOURCE_SETTINGS_FOR_LEADS_AND_CALLS: 'frontend::show_source_settings_for_leads_and_calls:: Show source settings for leads and calls',
    SF_FEATURE_FLAG_SOURCE_SETTINGS_DISTRIBUTION_HOVER: 'frontend::source_settings_distribution_hover::Source Settings Distribution on hover',
    SF_FEATURE_SHOW_INTEGRATION_IN_TRACKINGINTEGRATION: "frontend::show_integration_in_trackingintegration::Show integration dropdwon in Trackingintegration",
    SF_FEATURE_FLAG_ClICK_CONVERSION_SYNC_S3_UPLOAD: 'both::click_conversion_sync_s3_upload::Upload click conversion upload file to s3 synchronously',
    SF_FEATURE_FLAG_SHOW_NOTIFICATIONS_TERMINAL: 'frontend::show_notifications_terminal::Show Notifications Terminal',
    SF_FEATURE_NEW_ADMIN_CLIENTS_PAGE: "frontend::show_new_admin_clients_page::Show new admin clients page",
    SF_FEATURE_FLAG_ClICK_CONVERSION_DIRECT_S3_UPLOAD: 'both::click_conversion_direct_s3_upload::Upload click conversion upload file to s3 directly using presigned url',
    SF_FEATURE_FLAG_DISPOSITION_UPLOAD: 'both::disposition_upload::Enable disposition file upload for carriers',
    SF_FEATURE_FLAG_POSTBACK_URL_FOR_CLICKS: 'backend::postback_url_for_clicks::Post back url functionality for click campaigns',
    SF_FEATURE_FLAG_ENABLE_IMPRESSIONS_LEVEL_REPORT: 'backend::enable_impressions_level_report::Enable Impressions Level report in analytics smart view',
    SF_FEATURE_FLAG_SHOW_EVENTS_AND_ROLLBACK_OPTION: 'frontend::show_events_and_rollback_option::show events and rollback option',
    SF_FEATURE_FLAG_ADMIN_ACCOUNT_NOTIFICATIONS: 'both::admin_account_notifications::Send email notifications to subscribed admin accounts based on preferences on account events',
    SF_FEATURE_FLAG_SHOW_FILTERS_IN_EMAIL_ACTIVITY: 'both::show_filters_in_email_activity::Show filters in email activity',
    SF_FEATURE_FLAG_SHOW_EMAIL_STATUS_CHECK: 'frontend::show_email_status_check::Shows email status check modal',
    SF_FEATURE_FLAG_LOGIN_AS_ANOTHER_ADMIN_USER: 'both::login_as_another_admin::Ability for admins to login to other employees accounts',
    SF_FEATURE_FLAG_SHOW_CALL_TRANSCRIPTION: 'frontend::show_call_transcription::Show call transcription in call details page',
    SF_FEATURE_FLAG_SHOW_DASHBOARD_CUSTOMIZE_COLUMNS: 'frontend::show_dashboard_customize_columns::Show customize columns in dashboard',
    SF_FEATURE_FLAG_SHOW_CLIENT_EMAIL_EVENTS: "frontend::show_client_email_events::Show email events for all emails sent to client users",
    SF_FEATURE_FLAG_SHOW_INSURANCE_CARRIERS: "frontend::show_insurance_carriers::Show insurance carriers in the tools dropdown",
    SF_FEATURE_FLAG_RANDOM_CALL_TRANSCRIPTIONS: 'frontend::random_call_transcriptions::Random call transcriptions or transcriptions from api based on feature flag',
    SF_FEATURE_FLAG_CONVERSION_UPLOAD_FOR_LEADS_AND_CALLS: 'frontend::conversion_upload_for_leads_and_calls::Conversion upload for leads and calls',
    SF_FEATURE_FLAG_SHOW_USER_ACTIVITY: 'frontend::show_admin_user_activity::Show user activity in admin view inside tools dropdown',
    SF_FEATURE_FLAG_SHOW_TERMS_OF_SERVICES: 'frontend::show_terms_of_services::Show terms of services in the tools dropdown',
    FRONTEND_SHOW_ADMIN_LEAD_REFUND_REASONS: 'frontend::show_admin_lead_refund_reasons::Show admin lead refund reasons',
    SF_FEATURE_FLAG_SHOW_PAYMENT_TERMS: 'frontend::show_payment_terms::Show payment terms in the tools dropdown',
    SF_FEATURE_FLAG_SHOW_PIXEL_STATS_IN_ANALYTICS_PAGE: 'frontend::show_pixel_stats_in_analytics_page::Show pixel stats in analytics page',
    SF_FEATURE_FLAG_SHOW_CALL_TRANSCRIPTION_TOPICS: 'frontend::show_call_transcription_topics::Show call transcription topics in settings page',
    SF_FEATURE_FLAG_SHOW_TERMS_OF_SERVICES_IN_CLIENT_VIEW: 'frontend::show_terms_of_services_in_client_view::Show terms of services in client view',
    SHOW_ADMIN_TWILIO_NUMBER_UNDER_CALL: 'frontend::show_admin_twilio_number_under_call::Show admin twilio number under call',
    SHOW_LEAD_INTEGRATION_CONFIG: "frontend::show_lead_integration_config::Show lead integration config",
    SF_FEATURE_FLAG_PRIVATE_S3_ACCESS: 'both::private_s3_access::Privately access s3 resources',
    SF_FEATURE_FLAG_STATUS_COLUMN_IN_LEADS_AND_CALLS: 'frontend::status_column_in_leads_and_calls::Show status column in leads and calls',
    SF_FEATURE_FLAG_LEAD_INTEGRATION_PING_PHASE: 'both::lead_integration_ping_phase::Display and process for ping phase of integration',
    SF_FEATURE_FLAG_DASHBOARD_FOR_ADMIN_PORTAL: 'frontend::dashboard_for_admin_portal::dashboard for admin portal',
    SF_FEATURE_FLAG_CAMPAIGNS_WITH_SIGNUP: 'both::campaign_creation_with_signup::Create campaigns when signing up',
    SF_FEATURE_FLAG_NEW_CAMPAIGNS_PAGE_UI: 'both::new_campaigns_page_ui::New campaigns page UI',
    SF_FEATURE_FLAG_SHOW_STATUS_IN_CALLS: 'frontend::show_status_in_calls_page::Show Status in Calls Page',
    SF_FEATURE_FLAG_BILL_COM_INTEGRATION: 'both::bill_com_api_integration::Integration of Bill.com APIs',
    SF_FEATURE_FLAG_SHOW_CALL_PRICES_IN_ADMIN_CALLS_PAGE: 'frontend::show_call_prices_in_admin_calls_page::Show call prices in admin calls page',
    SF_FEATURE_FLAG_SHOW_LEAD_PRICES_IN_ADMIN_LEADS_PAGE: 'frontend::show_lead_prices_in_admin_calls_page::Show lead prices in admin leads page',
    SF_FEATURE_FLAG_SHOW_LEAD_REFUND_IN_ADMIN_LEADS_PAGE: 'frontend::show_lead_refund_in_admin_calls_page::Show lead refund in admin leads page',
    SF_FEATURE_FLAG_URL_FILTERS: 'frontend::enable_url_filters::Enable url filters',
    SF_FEATURE_FLAG_SHOW_WHITELISTED_BRANDS: 'both::show_whitelisted_brands::Show whitelisted brands',
    SF_FEATURE_FLAG_SHOW_ADMIN_SF_FILTERS: 'frontend::show_admin_sf_filters::Show admin sf filters',
    SF_FEATURE_FLAG_SHOW_ADMIN_ANALYTICS_PIXEL_STATS: 'frontend::show_admin_analytics_pixel_stats::Show admin analytics pixel stats',
    SF_FEATURE_FlAG_SHOW_PIXEL_STATS_FOR_LEADS_AND_CALLS: 'frontend::show_pixel_stats_for_leads_and_calls::Show pixel stats for leads and calls',
    SF_FEATURE_FLAG_SHOW_FILTER_PACKAGES: 'frontend::show_filter_packages::Show filter packages',
    SF_FEATURE_FLAG_SHOW_PLATFORM_SETTINGS: 'frontend::show_platform_settings::Show platform settings',
    SF_FEATURE_FLAG_SHOW_ZIP_TIER_SETTINGS: 'frontend::show_zip_tier_settings::Show zip tier settings',
    SF_FEATURE_FLAG_SHOW_ACCEPT_UNKNOWN_IN_MODIFIERS: 'frontend::show_accept_unknown_in_modifiers::Show accept unknown in modifiers',
    SF_FEATURE_FLAG_SHOW_NOTES_COLUMN_FOR_ADMIN_VIEW: 'frontend::show_notes_column_for_admin_view::Show notes column for admin view',
    SF_FEATURE_FLAG_INSURANCE_CARRIERS_IN_CREATIVES: 'frontend::insurance_carriers_in_creatives::Show insurance carriers in creatives',
    SF_FEATURE_FLAG_ALL_PRODUCTS_OPTION_IN_ADMIN_DASHBOARD: 'frontend::all_products_option_in_admin_dashboard::Show all products option in admin dashboard',
    SF_FEATURE_FLAG_ADMIN_CLICKS_API_VERSION: 'frontend::admin_clicks_api_version::Set api version for admin dashboard and analytics clicks stats',
    SF_FEATURE_FLAG_SHOW_PING_DETAILS_MODAL: 'frontend::show_ping_details_modal::Show ping details modal',
    SF_FEATURE_FLAG_SHOW_WHITELABELED_BRANDS_FEATURE_FLAGS: 'frontend::show_whitelabeled_brands_feature_flags::Show whitelabeled brands feature flags',
    SF_FEATURE_FLAG_SHOW_INTERCOM_CHAT_BOX: 'frontend::show_intercom_chat_box::Show intercom chat box',
    SF_FEATURE_FLAG_SHOW_WHITELISTED_BRAND_USER_MAPPING: 'frontend::show_whitelisted_brand_user_mapping::Show whitelisted brand user mapping',
    SF_FEATURE_FLAG_USE_NEW_PAYMENT_SETUP: 'frontend::use_stripe_web_elements_for_billing_registration::Use stripe web elements for billing registration',
    SF_FEATURE_FLAG_USE_NEW_LOGIC_FOR_COMPARE_TO: 'frontend::use_new_logic_for_dashboard_compare_to::Use new logic for dashboard compare to filter',
    SF_FEATURE_FLAG_NEW_TERRITORY_UI: 'both::new_territory_ui::New UI for territories in Campaign Settings',
    SF_FEATURE_FLAG_ADMIN_CALLS_API_VERSION: 'frontend::admin_calls_api_version::Set api version for admin dashboard and analytics calls stats',
    SF_FEAURE_FLAG_ENABLE_STICKY_COLUMNS: 'frontend::enable_sticky_columns::Enable sticky columns',
    SF_FEATURE_FLAG_INVOICE_FILTER_ADMIN_ANALYTICS: 'both::invoice_filter_admin_analytics::Show invoice filter in admin analytics',
    SF_FEATURE_FLAG_ADMIN_ANALYTICS_PRODUCT_GROUP_BY: 'both::admin_analytics_product_type_group_by::Show Product Type group by in Admin Analytics',
    SF_FEATURE_FLAG_URL_FILTERS_ON_ADGROUPS: 'frontend::enable_url_filters_on_adgroups::Enable url filters on adgroups',
    SF_FEATURE_FLAG_URL_FILTERS_ON_PROFILES: 'frontend::enable_url_filters_on_profiles::Enable url filters on profiles',
    SF_FEATURE_FLAG_URL_FILTERS_ON_CLIENT_USER_MANAGEMENT: 'frontend::enable_url_filters_on_client_user_management::Enable url filters on client user management',
    SF_FEATURE_FLAG_URL_FILTERS_ON_SOURCE_SETTINGS: 'frontend::enable_url_filters_on_source_settings::Enable url filters on source settings',
    SF_FEATURE_FLAG_URL_FILTERS_ON_INVOICES: 'frontend::enable_url_filters_on_invoices::Enable url filters on invoices',
    SF_FEATURE_FLAG_URL_FILTERS_ON_CAMPAIGNS: 'frontend::enable_url_filters_on_campaigns::Enable url filters on campaigns',
    SF_FEATURE_FLAG_URL_FILTERS_ON_CREATIVES: 'frontend::enable_url_filters_on_creatives::Enable url filters on creatives',
    SF_FEATURE_FLAG_URL_FILTERS_ON_BILLING: 'frontend::enable_url_filters_on_billing::Enable url filters on billing',
    SF_FEATURE_FLAG_URL_FILTERS_ON_LEADS_CALLS_CAMPAIGN_ANALYSIS: 'frontend::enable_url_filters_on_leads_calls_campaign_analysis::Enable url filters on leads calls campaign analysis',
    SF_FEATURE_FLAG_URL_FILTERS_ON_LEADS: 'frontend::enable_url_filters_on_leads::Enable url filters on leads',
    SF_FEATURE_FLAG_URL_FILTERS_ON_CALLS: 'frontend::enable_url_filters_on_calls::Enable url filters on calls',
    SF_FEATURE_FLAG_URL_FILTERS_ON_ADMIN_RECEIPT_LOGS: 'frontend::enable_url_filters_on_admin_receipt_logs::Enable url filters on admin receipt logs',
    SF_FEATURE_FLAG_URL_FILTERS_ON_ADMIN_USER_MANAGEMENT: 'frontend::enable_url_filters_on_admin_user_management::Enable url filters on admin user management',
    SF_FEATURE_FLAG_URL_FILTERS_ON_ADMIN_CLIENT_USERS: 'frontend::enable_url_filters_on_admin_client_users::Enable url filters on admin client users',
    SF_FEATURE_FLAG_URL_FILTERS_ON_ADMIN_USER_ACTIVITY: 'frontend::enable_url_filters_on_admin_user_activity::Enable url filters on admin user activity',
    SF_FEATURE_FLAG_URL_FILTERS_ON_ADMIN_EMAIL_ACTIVITY: 'frontend::enable_url_filters_on_admin_email_activity::Enable url filters on admin email activity',
    SF_FEATURE_FLAG_URL_FILTERS_ON_CLIENT_EMAIL_ACTIVITY: 'frontend::enable_url_filters_on_client_email_activity::Enable url filters on client email activity',
    SF_FEATURE_FLAG_URL_FILTERS_ON_ADMIN_TWILIO_NUMBERS: 'frontend::enable_url_filters_on_admin_twilio_numbers::Enable url filters on admin twilio numbers',
    SF_FEATURE_FLAG_CLIENT_CHANGE_HISTORY_URL_FILTERS: 'frontend::enable_url_filters_on_client_change_history::Enable url filters on client change history',
    SF_FEATURE_FLAG_ADMIN_CHANGE_HISTORY_URL_FILTERS: 'frontend::enable_url_filters_on_admin_change_history::Enable url filters on admin change history',
    SF_FEATURE_FLAG_URL_FILTERS_ON_CLICKS_CAMPAIGN_ANALYSIS_PAGE: 'frontend::enable_url_filters_on_clicks_campaign_analysis_page::Enable url filters on clicks campaign analysis page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_LEADS_PAGE: 'frontend::enable_customize_columns_ordering_on_leads_page::Enable customize columns ordering on leads page',
    SF_FEATURE_FLAG_SYNDI_CLICKS_FEATURE_IN_API_TOKENS: 'frontend::enable_syndi_clicks_feature_in_api_tokens_page::Enable syndi clicks feature in api tokens page',
    SF_FEATURE_FLAG_SHOW_FAILURE_REASON_IN_INTEGRATIONS: 'frontend::show_failure_reason_in_integrations::Show failure reason in integrations',
    SF_FEATURE_FLAG_SHOW_LEAD_INTEGRATION_FOR_CLICKS: 'frontend::show_lead_integration_for_clicks::Show lead integration for clicks',
    SF_FEATURE_FLAG_SHOW_DOWNLOAD_SCHEDULED_REPORT_COLUMN: 'frontend::show_download_scheduled_report_column::Show download scheduled report column',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CALLS_PAGE: 'frontend::enable_customize_columns_ordering_on_calls_page::Enable customize columns ordering on calls page',
    SF_FEATURE_FLAG_FRONTEND_INDIVIDUAL_LEADS_SMART_VIEW: 'frontend::show_individual_leads::Show Smart Views on Analytics page which return individual lead listings',
    SF_FEATURE_FLAG_SHOW_TEST_REPORT_SCHEDULE_MODAL: 'both::show_test_report_schedule_modal::Show test report schedule modal',
    SF_FEATURE_FLAG_SHOW_ANY_TRANSFER_TYPE: 'frontend::show_any_transfer_type_option::Show any option for transfer type in call campaign admin setting',
    SF_FEATURE_FLAG_SHOW_QUOTE_FUNNELS: 'frontend::show_quote_funnels::Show Quote Funnels in Sidebar',
    SF_FEATURE_FLAG_SHOW_INDIVIDUAL_ZIP_CODES_AT_TERRITORY: 'frontend::show_individual_zip_codes_at_territory::Show individual zipcodes at retail territory option',
    SF_FEATURE_FLAG_SHOW_QUOTE_FUNNELS_AT_TRACKING: 'frontend::show_quote_funnels_at_tracking::Show Quote Funnels At Tracking',
    SF_FEATURE_FLAG_SHOW_SYNDI_CLICKS_STATS_IN_ADMIN_DASHBOARD: 'frontend::show_syndi_clicks_stats_in_admin_dashboard::Show syndi clicks stats in admin dashboard',
    SF_FEATURE_FLAG_SHOW_CONVERSION_UPLOAD_DETAILS_PAGE: 'frontend::show_conversion_upload_details_page::Show conversion upload details page',
    SF_FEATURE_FLAG_SHOW_CLIENTS_TERMS_OF_SERVICE_TAB: 'frontend::show_clients_terms_of_service_tab::Show clients terms of service tab',
    SF_FEATURE_FLAG_TO_SHOW_RECENT_VISIT: 'frontend::show_recent_visit_at_admin_sidebar::Show recent visit at admin sidebar',
    SF_FEATURE_FLAG_SHOW_FILTER_PRICES_AT_TARGETING: 'frontend::show_filter_prices_at_targeting::Show filter prices at Targeting',
    SF_FEATURE_FLAG_REGISTRATION_PAGE_ENHANCEMENTS: 'both::registration_page_enhancements::Registration page enhancements',
    SF_FEATURE_FLAG_SHOW_ADMIN_CLIENT_REGISTRATION_COPY_LINK: 'frontend::show_admin_client_registration_copy_link::Show client registration copy link from admin portal',
    SF_FEATURE_FLAG_SHOW_CAMPAIGN_PRICE_INSTEAD_OF_SF_FILTER_PRICE: 'frontend::show_campaign_price_instead_of_sf_filter_price::Show campaign price instead of SF-filter price',
    SF_FEATURE_FLAG_RTB_ACCOUNT_DASHBOARD_STATS: 'backend::rtb_account_dashboard_stats::queries for rtb dashboard stats',
    SF_FEATURE_FLAG_SHOW_COPY_URL_ICON: 'frontend::show_copy_url_icon::Show copy url icon',
    SF_FEATURE_FLAG_SHOW_ADMIN_ONLY_ICON: 'frontend::show_admin_only_icon::Show admin only icon',
    SF_FEATURE_FLAG_SHOW_MINI_WIDGETS_AT_INTEGRATION_LOGS_PAGE: 'frontend::show_mini_widgets_at_integration_logs_page::Show mini widgets at integration logs page',
    SF_FEATURE_FLAG_SHOW_ADMIN_DASHBOARD_SMART_VIEWS: 'frontend::show_admin_dashboard_smart_views::Show Admin dashboard smart views',
    SF_FEATURE_FLAG_SHOW_NEW_TAB_DESIGN: 'frontend::show_new_tab_design::Show new tab design',
    SF_FEATURE_FLAG_SHOW_SORT_ICON_AT_DAILY_AND_MONTHLY_LIMIT: 'frontend::show_sort_icon_at_daily_and_monthly_limit::Show sort icon at daily and monthly limit',
    SF_FEATURE_FLAG_COMPARE_TO_OPTION_ADMIN_ANALYTICS: 'frontend::compare_to_feature_in_admin_analytics::Show compare to option in admin analytics',
    SF_FEATURE_FLAG_SHOW_TOTALS_DASHBOARD: 'frontend::show_totals_client_dashboard::Show totals in Client Dashboard tables',
    SF_FEATURE_FLAG_COMPARE_TO_OPTION_CLIENT_ANALYTICS: 'frontend::compare_to_feature_in_client_analytics::Show compare to option in client analytics',
    SF_FEATURE_FLAG_BILLING_SETTING_INVOICE_CHANGE: 'both::billing_setting_invoice_change::Showing previous billing data in case the account billing setting were changed',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_PROSPECTS_PAGE: 'frontend::enable_customize_columns_ordering_on_prospects_page::Enable customize columns ordering on prospects page',
    SF_FEATURE_FLAG_SHOW_CONFIG_WARNING_CAMPAIGN_LEAD_INTEGRATIONS: 'frontend::show_config_warning_campaign_lead_integrations::Show config warning campaign lead integrations',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CAMPAIGNS_PAGE: 'frontend::enable_customize_columns_ordering_on_campaigns_page::Enable customize columns ordering on campaigns page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CLICKS_DASHBOARD_PAGE: 'frontend::enable_customize_columns_ordering_on_clicks_dashboard_page::Enable customize columns ordering on clicks dashboard page',
    SF_FEATURE_FLAG_SHOW_CAMPAIGNS_TAB_ON_CLICKS_DASHBOARD: 'frontend::show_campaigns_tab_on_clicks_dashboard::Show Campaigns tab on clicks dashboard',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_LEADS_DASHBOARD_PAGE: 'frontend::enable_customize_columns_ordering_on_leads_dashboard_page::Enable customize columns ordering on leads dashboard page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CALLS_DASHBOARD_PAGE: 'frontend::enable_customize_columns_ordering_on_calls_dashboard_page::Enable customize columns ordering on calls dashboard page',
    SF_FEATURE_FLAG_ADD_GOOGLE_API_SCRIPT: 'frontend::add_google_api_script::Enable google apis',
    SF_FEATURE_FLAG_TRANSACTION_FEE: 'both::transaction_fee::Transaction fee for each product type',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_ADGROUPS_PAGE: 'frontend::enable_customize_columns_ordering_on_adgroups_page::Enable customize columns ordering on adgroups page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CLICKS_SOURCE_SETTINGS_PAGE: 'frontend::enable_customize_columns_ordering_on_clicks_source_settings_page::Enable customize columns ordering on clicks source setting page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_PROFILES_PAGE: 'frontend::enable_customize_columns_ordering_on_profiles_page::Enable customize columns ordering on profiles page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_ANALYTICS_PAGE: 'frontend::enable_customize_columns_ordering_on_analytics_page::Enable customize columns ordering on analytics page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CLICK_CONVERSION_LOGS_PAGE: 'frontend::enable_customize_columns_ordering_on_click_conversion_logs_page::Enable customize columns ordering on click conversion logs page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_ADMIN_CLIENTS_PAGE: 'frontend::enable_customize_columns_ordering_on_admin_clients_page::Enable customize columns ordering on admin clients page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_QUOTE_FUNNEL_DASHBOARD_PAGE: 'frontend::enable_customize_columns_ordering_on_quote_funnel_dashboard_page::Enable customize columns ordering on quote funnel dashboard page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_SYNDI_CLICKS_DASHBOARD_PAGE: 'frontend::enable_customize_columns_ordering_on_syndi_clicks_dashboard_page::Enable customize columns ordering on syndi clicks dashboard page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_LEADS_CALLS_SOURCE_SETTINGS_PAGE: 'frontend::enable_customize_columns_ordering_on_leads_calls_source_settings_page::Enable customize columns ordering on leads calls source setting page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_ADMIN_ANALYTICS_PAGE: 'frontend::enable_customize_columns_ordering_on_admin_analytics_page::Enable customize columns ordering on admin analytics page',
    SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_USER_ACTIVITY_PAGE: 'frontend::enable_customize_columns_ordering_on_user_activity_page::Enable customize columns ordering on user activity page',
    SF_FEATURE_FLAG_ADMIN_ONLY_FILTERS: 'both::enable_admin_only_sf_filters::Enable admin only filters',
    SF_FEATURE_FLAG_SHOW_BPFM_STATUS_AT_QUOTE_FUNNEL_CAMPAIGN_ADMIN_SETTING: 'frontend::show_bpfm_status_at_quote_funnel_campaign_admin_setting::Show bpfm status at quote funnel campaign admin setting',
    SF_FEATURE_FLAG_ENABLE_CUSTOM_CONSENT_UI: 'frontend::enable_custom_consent_ui::Enable custom prospects consent ui',
    SF_FEATURE_FLAG_ENABLE_TRAFFIC_TYPE_FILTER_IN_CALL_CAMPAIGN_ANALYSIS: 'frontend::enable_traffic_type_filter_in_call_campaign_analysis::Enable traffic type filter in call campaign analysis',
    SF_FEATURE_FLAG_ENABLE_DISQUALIFICATION_CAUSE_FILTER_IN_CAMPAIGN_ANALYSIS: 'frontend::enable_disqualification_cause_filter_in_campaign_analysis::Enable disqualification cause filter in campaign analysis',
    SF_FEAURE_FLAG_ENABLE_STICKY_COLUMNS_FOR_CREATIVES: 'frontend::enable_sticky_columns_for_creatives::Enable sticky columns for creatives',
    SF_FEATURE_FLAG_SHOW_DETAILED_GRAPH_AT_INTEGRATION_LOGS_PAGE: 'frontend::show_detailed_graph_at_integration_logs_page::Show detailed graph at integration logs page',
    SF_FEATURE_FLAG_SHOW_ADMIN_SETTINGS_IN_ADGROUPS: 'frontend::show_admin_settings_in_adgroups::Show admin settings in adgroups',
    SF_FEATURE_FLAG_SHOW_POPUP_IN_GOAL_FORM: 'frontend::show_popup_in_goal_form::Show popup in goal form',
    SF_FEATURE_FLAG_EDIT_GOAL_TCPA_DISCLAIMER_TEXT: 'frontend::edit_tcpa_disclaimer_text::Edit TCPA disclaimer text',
    SF_FEATURE_FLAG_ADMIN_ANALYTICS_ZIPCODE_GROUP_BY: 'frontend::admin_analytics_zipcode_group_by::Show Zipcode group by in Admin Analytics',
    SF_FEATURE_FLAG_SHOW_CONVERSATION_AND_SUMMARY_TAB: 'frontend::sf_feature_flag_show_conversation_and_summary_tab::Show conversation and summary tab',
    SF_FEATURE_FLAG_RTB_ANALYTICS_ALL_PRODUCTS_OPTION: 'frontend::rtb_analytics_all_products_option::Show all products option in analytics for RTB account',
    SF_FEATURE_FLAG_DEVELOPER_DASHBOARD: 'frontend::sf_feature_flag_developer_dashboard:: Show dashboard for developer',
    SF_FEATURE_FLAG_REPORTING_CONSISTENCY: 'frontend::reporting_consistency::Show Reporting Consistency in Dev Monitor',
    SF_FEATURE_FLAG_MULTIPLE_CALL_FILTERS: 'frontend::sf_feature_flag_multiple_call_filters:: Show multiple call filters',
    SF_FEATURE_FLAG_BID_LEVEL_REPORT: 'frontend::bid_level_report::Bid Level Report in Analytics for clicks',
    SF_FEATURE_FLAG_BID_LEVEL_REPORT_FOR_CALLS: 'frontend::bid_level_report_for_calls::Bid Level Report in Analytics for calls',
    SF_FEATURE_FLAG_RETRY_ON_QUOTE_FORM_SUBMIT: 'frontend::retry_on_quote_form_submit::Retry on quote form submit',
    SF_FEATURE_FLAG_GENERATE_KEY_PAIR: 'frontend::generate_key_pair_in_scheduled_report::Enable generate key pair in schedule report',
    SF_FEATURE_FLAG_CAPTURE_SESSION: 'frontend::capture_session::Capture session',
    SF_FEATURE_FLAG_CLIENT_META_IN_QUOTE_FORMS: 'both::client_meta_in_quote_forms::Client meta in quote forms',
    SF_FEATURE_FLAG_LEAD_DETAIL_EXPORT: 'frontend::lead_detail_export::Lead details export',
    SF_FEATURE_FLAG_REMOVE_TOTAL_NUMBER_OF_PAGES: 'both::remove_total_number_of_pages::Remove total number of pages',
    SF_FEATURE_FLAG_CLICK_MATERIALIZED_VIEW_ANALYTICS_STATS: 'both::click_materialized_view_analytics_stats::Use materialized views queries for click stats in analytics',
    SF_FEATURE_FLAG_MARKETING_GROUP_ANALYTICS: 'both::marketing_group_analytics::Enable marketing group filter and group by in analytics',
    SF_FEATURE_FLAG_ENABLE_KEYWORD_SOURCE_GROUP_BY: 'frontend::enable_keyword_source_group_by::Enable Keyword Source group by in Analytics and Admin Analytics',
    SF_FEATURE_FLAG_MOTORCYCLE_LEAD_TYPE_FOR_CLICKS: 'frontend::motorcycle_lead_type::Enable motorcycle lead type for clicks',
    SF_FEATURE_FLAG_USE_DB_RECEIPT_TYPE_DEBIT: 'both::use_db_receipt_type_debit::Use receipt type debit from DB',
    SF_FEATURE_FLAG_SHOW_RECEIPT_TYPE_IN_ADMIN_PORTAL: 'frontend::show_receipt_types_in_admin_portal::Show receipt types in admin portal',
    SF_FEATURE_FLAG_URL_FILTERS_ON_ANALYTICS: 'frontend::enable_url_filters_on_analytics::Enable url filters on analytics',
    SF_FEATURE_FLAG_CLICK_ANALYTICS_PREFILL_FAILURE: 'both::click_analytics_prefill_failure::Click analytics prefill failure',
    SF_FEATURE_FLAG_SHOW_CLOSEIO_ICON_AT_ADMIN_CLIENT_PAGE: 'frontend::show_closeio_icon_at_admin_clients_page::Show CloseIO icon at admin clients page',
    SF_FEATURE_FLAG_MOTORCYCLE_LEAD_TYPE_FOR_LEADS_AND_CALLS: 'frontend::motorcycle_lead_type_for_leads_calls::Enable motorcycle lead type for leads and calls',
    SF_FEATURE_FLAG_URL_FILTERS_ON_DASHBOARD: 'frontend::enable_url_filters_on_dashboard::Enable url filters on dashboard',
    SF_FEATURE_FLAG_DOW_GROUP_BY_ANALYTICS: 'frontend::enable_dow_group_by_on_analytics::Enable Day of Week group by on analytics',
    SF_FEATURE_FLAG_SHOW_WON_CAMPAIGN_ANALYSIS: 'frontend::show_won_campaign_analysis::Show won column for clicks and leads in campaign analysis',
    SHOW_DELETE_ICON_ON_CLIENTS_PAGE_FOR_REGISTRATION_PENDING_USERS: 'frontend::show_delete_icon_on_clients_page_for_registration_pending_users::Show delete icon on clients page for deleting registration pending user',
    SF_FEATURE_FLAG_WIN_RATE: 'both::win_rate_column_for_campaigns_page::Win rate column for campaigns page',
    SF_FEATURE_FLAG_DAY_OF_WEEK_FILTER_IN_ANALYTICS: 'frontend::day_of_week_filter_in_analytics::Enable day of week filter in analytics',
    SF_FEATURE_FLAG_USE_NEW_WIN_RATE_FORMULA: 'frontend::use_new_win_rate_formula::Enable new win rate formula',
    SF_FEATURE_FLAG_SHOW_PREFILL_PERNCENTAGE_IN_ANALYTICS_GROUP_BY: 'frontend::show_prefill_percentage_in_analytics_group_by::Show prefill percentage in analytics group by',
    SF_FEATURE_FLAG_SHOW_PII_AVAILABILITY_IN_GROUP_BY: 'frontend::show_pii_availability_in_group_by::Show PII Availability in group by',
    SF_FEATURE_FLAG_RTB_AUTO_FIELDS_ANALYTICS_GROUP_BY: 'frontend::rtb_auto_fields_analytics_group_by::Show RTB auto fields in analytics group by',
    SF_FEATURE_FLAG_SHOW_RDS_MONITOR_IN_DEV_MONITOR: 'frontend::show_rds_monitor_in_dev_monitor::Show rds monitor in dev monitor',
    SF_FEATURE_FLAG_SHOW_DS_APP_IN_DEV_MONITOR: 'frontend::show_ds_app::Show data science app in dev monitor',
    SF_FEATURE_FLAG_SHOW_ROAS: 'frontend::show_roas::Show ROAS column',
    SF_FEATURE_FLAG_SHOW_REVENUE_PER_PIXEL: 'frontend::show_revenue_per_pixel::Show Revenue per Pixel column in Analytics',
    SF_FEATURE_FLAG_SHOW_INSURANCE_CARRIERS_AT_CAMPAIGN_ADMIN_SETTINGS: 'frontend::show_insurance_carriers_at_campaign_admin_settings::Show Insurance Carriers at campaign admin settings',
    SF_FEATURE_SHOW_INBOUND_ONLY_CALL_CAMPAIGNS: 'both::show_inbound_only_call_campaigns::Show inbound only call campaigns',
    SF_FEAURE_FLAG_DUPLICATE_EXISITING_BRAND: 'both::ability_to_duplicate_existing_brand::Ability to duplicate existing brands quote funnels and ad creatives',
    SF_FEATURE_FLAG_SHOW_CALL_RECORDING_AT_QUOTE_FUNNEL_CAMPAIGN_ADMIN_SETTING: 'frontend::show_call_recording_at_quote_funnel_campaign_admin_setting::Show call recording at quote funnel campaign admin setting',
    SF_FEATURE_FLAG_RTB_CALL_CAMPAIGN_ADMIN_SETTINGS: 'frontend::rtb_call_campaign_admin_settings::Enable Admin Settings for RTB Call Campaigns',
    SF_FEATURE_FLAG_SHOW_HOME_CLAIMS_IN_BID_LEVEL_REPORT: 'both::show_home_claims_in_bid_level_report::Show home_claims of click_ping_details in bid level report',
    SF_FEATURE_FLAG_RTB_BRAND_UI_CHANGES: 'both::rtb_brand_ui_changes::RTB brand UI changes',
    SF_FEATURE_FLAG_USE_SIP_FOR_CALL_CAMPAIGN_TRANSFERS: 'both::use_sip_call_campaign_transfers::Use SIP for call campaign transfers',
    SF_FEATURE_FLAG_ENABLE_ZIP_ZODE_GROUP_BY_FOR_LEADS_IN_ANALYTICS: 'frontend::enable_zip_code_group_by_for_leads::Enable zip code group by for leads in analytics',
    SF_FEATURE_FLAG_ENABLE_ZIP_ZODE_GROUP_BY_FOR_CALLS_IN_ANALYTICS: 'frontend::enable_zip_code_group_by_for_calls::Enable zip code group by for calls in analytics',
    SF_FEATURE_FLAG_ENABLE_ZIP_ZODE_GROUP_BY_FOR_CLICKS_IN_ANALYTICS: 'frontend::enable_zip_code_group_by_for_clicks::Enable zip code group by for clicks in analytics',
    SF_FEATURE_FLAG_RDS_EVENTS_TAB: 'frontend::rds_events_tab::Enable RDS Events tab in RDS Monitor',
    SF_FEATURE_FLAG_CONSENT_LINKS_SHOWN: 'frontend::consent_links_shown::Consent Links shown on leads and calls details page',
    SF_FEATURE_FLAG_WIN_RATE_AT_ANALYTICS: 'frontend::win_rate_column_for_analytics_page::Win rate column for Analytics page',
    // SF_FEATURE_FLAG_ACCOUNT_MAX_LEADS_AND_CALLS: 'frontend::account_max_leads_and_calls::Display account-level max leads and calls fields', // TODO: Cleanup unsused flag
    SF_FEATURE_FLAG_CHECK_ACCOUNT_LEVEL_LEADS_MAX: 'both::check_account_level_leads_max::Check account level leads max limit for leads',
    SF_FEATURE_FLAG_USE_V2_ADMIN_CLIENTS_API: 'frontend::use_v2_admin_clients_api::Use V2 admin clients api',
    SF_FEATURE_FLAG_ENABLE_ACCOUNT_ID_SEARCH_IN_ADMIN_CLIENTS: 'frontend::enable_account_id_search_in_admin_clients::Enable account id search in admin clients',
    SF_FEATURE_FLAG_ENABLE_ZIP_ZODE_GROUP_BY_FOR_QUOTE_FUNNELS_IN_ANALYTICS: 'frontend::enable_zip_code_group_by_for_quote_funnels::Enable zip code group by for quote funnels in analytics',
    SF_FEATURE_FLAG_ENABLE_AID_CID_GROUP_BY: 'frontend::enable_aid_cid_group_by_for_all_brands::Enable Pub AID and Pub CID group by options',
    SF_FEATURE_FLAG_SHOW_REMNANT_AT_CALL_CAMPAIGN_ADMIN_SETTINGS: 'frontend::show_remnant_at_call_campaign_admin_setting::Show remnant at call campaign admin setting',
    SF_FEATURE_FLAG_REDUCE_APP_INITIAL_LOAD_API: 'frontend::reduce_app_initial_load_api::Reduce initial API calls in App.js and defer them to respective components',
    SF_FEATURE_FLAG_USE_ADMIN_DASHBOARD_REVAMP: 'frontend::use_admin_dashboard_revamp::Use admin dashboard revamp',
    SF_FEATURE_FLAG_ADMIN_SCHEDULED_REPORTS: 'both::admin_scheduled_reports::Enable admin scheduled reports for admin analytics',
    SF_FEATURE_FLAG_ADMIN_ANALYTICS_DAY_SEGMENT: 'both::admin_analytics_day_segment::Enable the Day Segment (Full Day / Through This Hour) filter on admin dashboard analytics',
    SF_FEATURE_FLAG_SHOW_SOURCE_TYPES_IN_SYNDI_CLICKS_CAMPAIGN_ADMIN_SETTINGS: 'frontend::show_source_types_in_syndi_clicks_campaign_admin_settings::Show Source Types in Syndi Clicks Campaign Admin Settings',
    SF_FEATURE_FLAG_ENABLE_SOURCE_TYPE_FILTER_CALLS_AND_LEADS: 'frontend::enable_source_type_filter_for_calls_and_leads::Enable source type filter for calls and leads in analytics and admin dashboard',
    SF_FEATURE_FLAG_USE_V3_API_FOR_AD_STATS: 'frontend::use_v3_api_for_ad_stats::Use v3 api for ad stats',
    SF_FEATURE_FLAG_USE_DASHBOARD_V3_API: 'frontend::use_dashboard_v3_api::Use dashboard v3 api',
    SF_FEATURE_FLAG_USE_DASHBOARD_CONVERSIONS_V3_API: 'frontend::use_dashboard_conversions_v3_api::Use dashboard conversions v3 api',
    SF_FEATURE_FLAG_USE_V3_API_FOR_CAMPAIGN_STATS: 'frontend::use_v3_api_for_campaign_stats::Use v3 api for campaign stats',
    SF_FEATURE_FLAG_USE_V3_API_FOR_CAMPAIGN_CONVERSION_STATS: 'frontend::use_v3_api_for_campaign_conversion_stats::Use v3 api for campaign conversion stats',
    SF_FEATURE_FLAG_SHOW_CONVERSION_AND_REVENUE_METRICS: 'frontend::show_conversion_and_revenue_metrics::Show total conversion and revenue metrics',
    SF_FEATURE_FLAG_SHOW_FORM_SUBMISSION_METRICS: 'frontend::show_form_submission_metrics::Show form submissions and submission rate on the campaigns list',
    SF_FEATURE_FLAG_SHOW_CALL_CVR: 'frontend::show_call_cvr::Show Call CVR column on the source settings page',
    SF_FEATURE_FLAG_ENABLE_CARD_CONVENIENCE_FEE: 'both::enable_credit_card_convenience_fee::Charge convenience fee for credit card payments',
    SF_FEATURE_FLAG_SHOW_BILLING_EVENTS_PAGE: 'frontend::show_billing_events_page::Show billing events page',
    SF_FEATURE_FLAG_SHOW_REFUND_POLICIES: 'frontend::show_refund_policies::Show policies in the tools dropdown',
    SF_FEATURE_FLAG_SHOW_ADMIN_INTEGRATION_LOGS_PAGE: 'frontend::show_admin_integration_logs_page::Show admin integration logs page',
    SF_FEATURE_FLAG_SHOW_BULK_EDIT_JOBS_PAGE: 'frontend::show_bulk_edit_jobs_page::Show Bulk Edit Jobs page under Tools',
    SF_FEATURE_FLAG_ASYNCHRONOUS_DELETION_OF_CONVERSION_UPLOAD: 'both::asynchronous_deletion_of_conversion_upload::Asynchronous deletion of conversion upload',
    SF_FEATURE_FLAG_ANALYTICS_CALL_OPPORTUNITIES_COUNT: 'both::analytics_call_opportunities_count::Call opportunities count',
    SF_FEATURE_FLAG_SHOW_ADMIN_CAMPAIGN_FULFILLMENT_PAGE: 'frontend::show_admin_campaign_fulfillment_page::Show admin campaigns fulfillment page',
    // Own flag on purpose: campaign_bid_suggestions is per-account, and per-actor flags read as OFF here.
    SF_FEATURE_FLAG_SHOW_MILO_DASHBOARD: 'both::milo_dashboard::Show the MILO staff dashboard (Pricing Advisor shadow data)',
    SF_FEATURE_FLAG_SHOW_CAMPAIGN_FULFILLMENT_PAGE: 'frontend::show_campaign_fulfillment_page::Show campaign fulfillment page',
    SF_FEATURE_FLAG_DISABLE_CONVERSION_LOG_OPTIONS_DURING_DELETION: 'frontend::disable_conversion_log_options_during_deletion::Disable conversion log options during deletion',
    SF_FEATURE_HOUSEHOLD_COLUMN_FOR_LEAD_DETAILS_PAGE: 'frontend::show_household_column_for_lead_details_page::Show household column for lead details page',
    SF_FEATURE_FLAG_ENABLE_GROUP_HEALTH_LEAD_TYPE: 'frontend::enable_group_health_lead_type::Enable group health lead type',
    SF_FEATURE_FLAG_ENABLE_SIC_CODE_TARGETING: 'both::enable_sic_code_targeting::Enable SIC code targeting',
    SF_FEATURE_FLAG_ENABLE_NUM_EMPLOYEES_IN_ANALYTICS: 'both::enable_num_employees_in_analytics::Enable num employees in analytics',
    SF_FEATURE_FLAG_NUMBER_OF_EMPLOYEES_GROUP_BY_FILTER: 'both::number_of_employees_group_by_filter::Enable number of employees group by filter in analytics and admin dashboard',
    SF_FEATURE_FLAG_CURRENT_CARRIER_GROUP_BY: 'frontend::current_carrier_group_by::Current Carrier group by in analytics',
    SF_FEATURE_FLAG_ENABLE_BUSINESS_GROUP_BY_OPTIONS: 'frontend::enable_business_group_by_options::Enable business group by options in analytics and admin analytics',
    SF_FEATURE_FLAG_ENABLE_CURRENT_MONTH_REPORT_FOR_CREDIT_CARD_USERS: 'frontend::enable_current_month_report_for_credit_card_users::Enable current month report for credit card users',
    SF_FEATURE_FLAG_SHOW_STATIC_BIDS_INTEGRATION: 'frontend::show_static_bids_integration::Enable Static Bids in integration form',
    SF_FEATURE_FLAG_INCLUDE_DISCARDED_CAMPAIGNS: 'both::include_discarded_campaigns::Include discarded campaigns in campaigns index based on start_date',
    SF_FEATURE_FLAG_USE_QF_SOURCE_STATS_STORED_PROCEDURES: "frontend::use_qf_source_stats_stored_procedures::Use QF source stats stored procedures",
    SF_FEATURE_FLAG_USE_QF_CREATIVES_STATS_STORED_PROCEDURES: "both::use_qf_creatives_stats_stored_procedures::Use QF creatives stats stored procedures",
    SF_FEATURE_FLAG_QF_CAMPAIGNS_AGGREGATED: 'frontend::qf_campaigns_page::Enable QF Campaigns page based on aggregated tables',
    SF_FEATURE_FLAG_GOAL_MARKETPLACE: 'both::goal_marketplace::Enable Goal Marketplace feature (campaigns, billing, reporting)',
    SF_FEATURE_FLAG_OFFSET_PAGINATION_APPLICATION: 'both::offset_pagination_application::Enable offset pagination across the application',
    SF_FEATURE_FLAG_ANALYZE_CAMPAIGN_IMPROVEMENTS: 'backend::analyze_campaign::use click results to get click campaign analysis data',
    SF_FEATURE_FLAG_CAMPAIGN_ANALYSIS_V2_ENABLED: 'both::campaign_analysis_v2_enabled::Enable V2 of campaign analysis',
    SF_FEATURE_FLAG_CALL_CAMPAIGN_ANALYSIS_V2_ENABLED: 'both::campaign_analysis_v2_enabled_for_calls::Enable V2 of campaign analysis for calls',
    SF_FEATURE_FLAG_SHOW_DISQUALIFICATION_REASON: 'frontend::show_disqualification_reason::Show disqualification reason column in campaign analysis',
    SF_FEATURE_FLAG_AD_GROUP_STATS_V4: 'frontend::ad_group_stats_v4::Use V4 Aggregated Stats API for Ad Groups page',
    SF_FEATURE_FLAG_DASHBOARD_STATS_V4: 'frontend::dashboard_stats_v4::Use V4 Aggregated Stats API for Dashboard page',
    SF_FEATURE_FLAG_SHOW_LEAD_AND_CALLS_NOTES: 'both::show_lead_and_calls_notes::Show lead and calls notes in detials and table views',
    SF_FEATURE_FLAG_SHOW_ALL_SOURCE_TYPES: 'frontend::show_all_source_types::Show all source types using new API that handles account filtering',
    // SF_FEATURE_FLAG_LEAD_INTEGRATIONS_V2: 'frontend::lead_integrations_v2::Use V2 lead integrations APIs',
    SF_FEATURE_FLAG_LEAD_INTEGRATIONS_V2_OPTIMIZATION: 'both::lead_integrations_v2_optimization::Use V2 lead integrations APIs',
    SF_FEATURE_FLAG_PRODUCT_SPECIFIC_SAMPLE_LEADS: 'both::product_specific_sample_leads::Use product-specific sample leads in integration builder', // Keep this off for Goal
    SF_FEATURE_FLAG_SHOW_BUSINESS_ENTITY_COLUMNS_IN_ANALYTICS_SMART_VIEW: 'both::benepath_lead_business_entity_columns_in_analytics_smart_view::Show Business Entity columns in Analytics Smart View',
    SF_FEATURE_FLAG_BACKEND_COLUMN_SORTING: 'both::backend_column_sorting::Enable backend column sorting across pages',
    SF_FEATURE_FLAG_CLIENT_ANALYTICS_BACKEND_FEATURES: 'both::client_analytics_backend_features::Enable backend export, sorting, and pagination for client analytics',
    SF_FEATURE_FLAG_SINGLE_REQUEST_CAMPAIGN_CREATE: 'frontend::single_request_campaign_create::Create campaign setup in a single request',
    SF_FEATURE_FLAG_SHOW_LEAD_MARKETPLACE_CPL_ADMIN_SETTINGS: 'frontend::show_lead_marketplace_cpl_admin_settings::Show Target CPL and Floor CPL in Lead Marketplace Campaign Admin Settings', // BM-9369: This flag now only controls Floor CPL; Target CPL has been removed
    SF_FEATURE_FLAG_ASSIGN_CREATIVE_FROM_CREATIVES_PAGE: 'frontend::assign_creative_from_creatives_page::Show Assign to Campaigns on the Creatives page',
    SF_FEATURE_FLAG_INTEGRATION_ROLE_PERMISSIONS: 'both::integration_role_permissions::Enforce role-based permissions (View, Manage) on integrations',
}

export const KEYWORD_SOURCE_GROUP_BY_OPTION = {
    label: 'Keyword Source',
    value: 'ks'
};

// Whitelist of UI dataFields that the backend can sort on, keyed by product type id
// and then by schema version ('v1' | 'v2').  The UI dataField is sent verbatim as
// `sort_column`; the backend owns the dataField -> DB column remap.  Any column not
// listed here keeps client-side sort (or no sort) and must not offer remote sort.
//
// v1 = legacy joined-relation query (campaign_analysis_*_v2_enabled? is false)
// v2 = ping-debug log query (campaign_analysis_*_v2_enabled? is true)
export const CAMPAIGN_ANALYSIS_BACKEND_SORTABLE_COLUMNS = {
    [PRODUCT_TYPE_IDS.CLICKS]: {
        // Clicks v1 (ClickOpportunity joined relation)
        v1: [
            'created_at', 'id', 'campaign_id', 'ping_id',
            'state', 'zip', 'won', 'position', 'excluded', 'de_duped',
        ],
        // Clicks v2 (ClickResult table)
        // ❌ schedule_modifier, source, modifier_math, accepted, base_bid, final_bid — not available
        v2: [
            'created_at', 'id', 'campaign_id', 'ad_group_id', 'ping_id', 'partner_id',
            'state', 'zip', 'qualified', 'won', 'disqualification_reason',
            'position', 'excluded', 'de_duped',
        ],
    },
    [PRODUCT_TYPE_IDS.LEADS]: {
        // Leads v1 (LeadOpportunity joined relation)
        // ❌ qualified, accepted, base_bid, final_bid, disqualification_reason, modifier_math, source, schedule_modifier
        v1: [
            'created_at', 'id', 'campaign_id', 'ping_id',
            'state', 'zip', 'won', 'position', 'de_duped', 'excluded',
        ],
        // Leads v2 (LeadPingDebugLogDetail table)
        // source + schedule_modifier use composite SQL sort, still backend-sortable
        // ❌ position, excluded — not available in leads v2
        v2: [
            'created_at', 'id', 'ping_id', 'state', 'zip', 'qualified', 'won',
            'accepted', 'base_bid', 'final_bid', 'campaign_id', 'ad_group_id',
            'disqualification_reason', 'modifier_math', 'source', 'schedule_modifier', 'de_duped',
        ],
    },
    [PRODUCT_TYPE_IDS.CALLS]: {
        // Calls v1 (CallOpportunity joined relation)
        // ❌ won, qualified, accepted, base_bid, final_bid, disqualification_reason, modifier_math, source, schedule_modifier
        v1: [
            'created_at', 'id', 'campaign_id', 'ping_id',
            'state', 'zip', 'position', 'excluded', 'de_duped',
        ],
        // Calls v2 (CallPingDebugLogDetail table) — leads v2 + position + excluded
        v2: [
            'created_at', 'id', 'ping_id', 'state', 'zip', 'qualified', 'won',
            'accepted', 'base_bid', 'final_bid', 'campaign_id', 'ad_group_id',
            'disqualification_reason', 'position', 'excluded',
            'modifier_math', 'source', 'schedule_modifier', 'de_duped',
        ],
    },
}

// Whitelist of UI dataFields that the backend can sort on for the Leads and Calls list pages.
// The dataField is sent verbatim as `sort_column`; the backend owns the DB column remap.
// Gated by SF_FEATURE_FLAG_BACKEND_COLUMN_SORTING.
export const LEADS_BACKEND_SORTABLE_COLUMNS = [
    // The Leads "Name" column uses dataField 'name' (mapped to lead_details.first_name on the
    // backend). It must NOT use the empty '' dataField, which the backend can't resolve.
    'name', 'created_at', 'disposition', 'lead_type_id', 'product_type_id',
    'lead_detail.phone', 'lead_detail.email',
    'lead_detail.state', 'lead_detail.city', 'lead_detail.address',
    'lead_detail.num_employees', 'lead_detail.search_pro',
    'campaign.name', 'campaign.brand.name', 'refund_status', 'price', 'ad_group_name',
];

export const CALLS_BACKEND_SORTABLE_COLUMNS = [
    'created_at', 'disposition', 'call_duration', 'lead_type_id',
    'lead_detail.state', 'lead_detail.city', 'status',
    'name', 'lead_detail.phone', 'price', 'lead_detail.insured',
    'lead_detail.address', 'lead_detail.zip', 'lead_detail.num_employees',
    'campaign.name', 'ad_group_name', 'transfer_type', 'aid', 'cid', 'refund_status',
    // 'drivers'/'vehicles' sort by the lead_applicants/lead_vehicles counts (resolved
    // server-side in leads_calls_sort_helper.rb).
    'drivers', 'vehicles',
];

export const METHOD_TYPE = {
    EDIT: "edit",
    CREATE: "create"
}

export const optionsKeyPairType = [
    { label: 'PEM', value: 'PEM' },
    { label: 'OpenSSH', value: 'OpenSSH' }
]

export const FEATURE_STATUS = {
    ACTIVE: "Active",
    PAUSED: "Paused"
}

export const TABS_CONSTANTS = {
    STATE_WISE_METRICS: "1",
    SOURCE_TYPE_WISE_METRICS: "2",
    CREATIVE_WISE_METRICS: "3",
    CONVERSION_PIXEL_WISE_METRICS: "4",
    INSURANCE_TYPES: "5",
    CAMPAIGN_WISE_METRICS: "6",
}

export const ADMIN_USER_DEPARTMENT_OPTIONS = [
    { label: "Account Management", value: "Account Management" },
    { label: "Business Development", value: "Business Development" },
    { label: "Contact Center", value: "Contact Center" },
    { label: "Engineering", value: "Engineering" },
    { label: "Executive", value: "Executive" },
    { label: "Iksha Labs", value: "Iksha Labs" },
    { label: "Marketing", value: "Marketing" },
    { label: "Sales", value: "Sales" },
    { label: "Accounting", value: "Accounting" },
]

export const ADMIN_STATUS = {
    PENDING: 'pending',
    ACTIVE: 'active',
    INACTIVE: 'inactive'
}

export const LOGIN_AS_USER_KEY = {
    ACCESS_ADMIN_TOKEN: 'access_admin_token',
    ACCESS_INSURANCE_IO_TOKEN: 'insurance_io_user_token',
    ADMIN_ACCESS: 'admin_access',
    ACCESS_USER_TOKEN: 'access_user_token'
}

export const SF_FILTER_TYPE = {
    AGE: "age"
}

export const LARGEST_NUMBER_OF_DIGITS = {
    THREE: 999,
    SEVEN: 9999999
}
export const ADMIN_USER_PERMISSIONS = {
    MANAGE_ADMIN_USERS: "manage_admin_users",
    MANAGE_CLIENT_USERS: "manage_client_users",
    MANAGE_ASSIGNED_ADMIN_USERS: "manage_assigned_admin_users",
    MANAGE_ASSIGNED_CLIENT_USERS: "manage_assigned_client_users",
    MANAGE_ADMIN_ROLES: "manage_admin_roles",
    VIEW_CLIENT_USERS: "view_client_users",
    VIEW_ASSIGNED_CLIENT_USERS: "view_assigned_client_users",
    VIEW_ADMIN_USERS: "view_admin_users",
    VIEW_ASSIGNED_ADMIN_USERS: "view_assigned_admin_users",
    MANAGE_FEATURE_FLAGS: "manage_feature_flags",
    MANAGE_ACCOUNTING: "manage_accounting",
    MANAGE_NOTIFICATION_TEMPLATES: "manage_all_notification_templates",
    SIGN_IN_TO_ASSIGNED_ADMIN_USERS: "sign_in_to_assigned_admin_users",
    VIEW_EMAIL_ACTIVITY: "view_email_activity",
    VIEW_USER_ACTIVITY: "view_user_activity",
    VIEW_CHANGE_HISTORY: "view_change_history",
    MANAGE_INSURANCE_CARRIERS: "manage_insurance_carriers",
    MANAGE_REFUND_REASONS: "manage_refund_reasons",
    ACCESS_WHITELISTED_BRANDS: "access_whitelisted_brands",
    MANAGE_WHITELISTED_BRANDS: "manage_whitelisted_brands",
    MANAGE_SF_FILTERS: "manage_sf_filters",
    MANAGE_FILTER_PACKAGES: "manage_filter_packages",
    MANAGE_WHITELISTED_BRANDS_FEATURE_FLAGS: "manage_whitelabeled_brands_feature_flags",
    MANAGE_PLATFORM_SETTINGS: "manage_platform_settings",
    VIEW_DEV_DASHBOARD: "view_dev_dashboard",
    VIEW_ADMIN_DASHBOARD: "view_admin_dashboard"
}

export const DASHBOARD_API_CALL_TYPE = {
    FETCH_MAIN_DATA: 'fetch_main_data',
    FETCH_STATE_WISE_METRICS: 'fetch_state_wise_metrics',
    FETCH_CREATIVE_WISE_METRICS: 'fetch_creative_wise_metrics',
    FETCH_SOURCE_TYPE_WISE_METRICS: 'fetch_source_type_wise_metrics',
    FETCH_CONVERSION_PIXEL_WISE_METRICS: 'fetch_conversion_pixel_wise_metrics',
    FETCH_DATE_RANGES: 'fetch_date_ranges',
    FETCH_COMPARE_TO_MAIN_DATA: 'fetch_compare_to_main_data',
    FETCH_INSURNCE_TYPE_WISE_METRICS: 'fetch_lead_type_wise_metrics',
    FETCH_CAMPAIGN_WISE_METRICS: 'fetch_campaign_wise_metrics',

    FETCH_LEADS_MAIN_DATA: 'fetch_leads_main_data',
    FETCH_LEADS_STATE_WISE_METRICS: 'fetch_leads_state_wise_metrics',
    FETCH_LEADS_DATE_RANGES: 'fetch_leads_date_ranges',
    FETCH_LEADS_COMPARE_TO_MAIN_DATA: 'fetch_leads_compare_to_main_data',
    FETCH_LEADS_CAMPAIGN_WISE_METRICS: 'fetch_leads_campaign_wise_metrics',
    FETCH_LEADS_INSURANCE_TYPE_WISE_METRICS: 'fetch_leads_lead_type_wise_metrics',

    FETCH_CALLS_MAIN_DATA: 'fetch_calls_main_data',
    FETCH_CALLS_STATE_WISE_METRICS: 'fetch_calls_state_wise_metrics',
    FETCH_CALLS_DATE_RANGES: 'fetch_calls_date_ranges',
    FETCH_CALLS_COMPARE_TO_MAIN_DATA: 'fetch_calls_compare_to_main_data',
    FETCH_CALLS_CAMPAIGN_WISE_METRICS: 'fetch_calls_campaign_wise_metrics',
    FETCH_CALLS_INSURANCE_TYPE_WISE_METRICS: 'fetch_calls_lead_type_wise_metrics',

    FETCH_SYNDI_CLICKS_MAIN_DATA: 'fetch_syndi_clicks_main_data',
    FETCH_SYNDI_CLICKS_STATE_WISE_METRICS: 'fetch_syndi_clicks_state_wise_metrics',
    FETCH_SYNDI_CLICKS_CREATIVE_WISE_METRICS: 'fetch_syndi_clicks_creative_wise_metrics',
    FETCH_SYNDI_CLICKS_SOURCE_TYPE_WISE_METRICS: 'fetch_syndi_clicks_source_type_wise_metrics',
    FETCH_SYNDI_CLICKS_CONVERSION_PIXEL_WISE_METRICS: 'fetch_syndi_clicks_conversion_pixel_wise_metrics',
    FETCH_SYNDI_CLICKS_DATE_RANGES: 'fetch_syndi_clicks_date_ranges',
    FETCH_SYNDI_CLICKS_COMPARE_TO_MAIN_DATA: 'fetch_syndi_clicks_compare_to_main_data',
    FETCH_SYNDI_CLICKS_INSURNCE_TYPE_WISE_METRICS: 'fetch_syndi_clicks_lead_type_wise_metrics',

    FETCH_QUOTE_FUNNELS_MAIN_DATA: 'fetch_quote_funnels_main_data',
    FETCH_QUOTE_FUNNELS_STATE_WISE_METRICS: 'fetch_quote_funnels_state_wise_metrics',
    FETCH_QUOTE_FUNNELS_CREATIVE_WISE_METRICS: 'fetch_quote_funnels_creative_wise_metrics',
    FETCH_QUOTE_FUNNELS_SOURCE_TYPE_WISE_METRICS: 'fetch_quote_funnels_source_type_wise_metrics',
    FETCH_QUOTE_FUNNELS_CONVERSION_PIXEL_WISE_METRICS: 'fetch_quote_funnels_conversion_pixel_wise_metrics',
    FETCH_QUOTE_FUNNELS_DATE_RANGES: 'fetch_quote_funnels_date_ranges',
    FETCH_QUOTE_FUNNELS_COMPARE_TO_MAIN_DATA: 'fetch_quote_funnels_compare_to_main_data',
    FETCH_QUOTE_FUNNELS_INSURNCE_TYPE_WISE_METRICS: 'fetch_quote_funnels_lead_type_wise_metrics',
}

export const ADMIN_DASHBOARD_API_CALL_TYPE = {
    FETCH_MAIN_DATA: 'fetch_main_data',
    FETCH_COMPARE_TO_MAIN_DATA: 'fetch_compare_to_main_data',
    FETCH_DATE_RANGES: 'fetch_date_ranges',

    FETCH_CLICKS_MAIN_DATA: 'fetch_clicks_main_data',
    FETCH_CLICKS_COMPARE_TO_MAIN_DATA: 'fetch_clicks_compare_to_main_data',
    FETCH_CLICKS_DATE_RANGES: 'fetch_clicks_date_ranges',

    FETCH_LEADS_MAIN_DATA: 'fetch_leads_main_data',
    FETCH_LEADS_COMPARE_TO_MAIN_DATA: 'fetch_leads_compare_to_main_data',
    FETCH_LEADS_DATE_RANGES: 'fetch_leads_date_ranges',

    FETCH_CALLS_MAIN_DATA: 'fetch_calls_main_data',
    FETCH_CALLS_COMPARE_TO_MAIN_DATA: 'fetch_calls_compare_to_main_data',
    FETCH_CALLS_DATE_RANGES: 'fetch_calls_date_ranges',

    FETCH_SYNDI_CLICKS_MAIN_DATA: 'fetch_syndi_clicks_main_data',
    FETCH_SYNDI_CLICKS_COMPARE_TO_MAIN_DATA: 'fetch_syndi_clicks_compare_to_main_data',
    FETCH_SYNDI_CLICKS_DATE_RANGES: 'fetch_syndi_clicks_date_ranges',

    FETCH_QUOTE_FUNNELS_MAIN_DATA: 'fetch_quote_funnels_main_data',
    FETCH_QUOTE_FUNNELS_COMPARE_TO_MAIN_DATA: 'fetch_quote_funnels_compare_to_main_data',
    FETCH_QUOTE_FUNNELS_DATE_RANGES: 'fetch_quote_funnels_date_ranges',

    FETCH_QUOTE_FUNNELS_LEADS_CALLS_MAIN_DATA: 'fetch_quote_funnels_leads_calls_main_data',
    FETCH_QUOTE_FUNNELS_LEADS_CALLS_COMPARE_TO_MAIN_DATA: 'fetch_quote_funnels_leads_calls_compare_to_main_data',
    FETCH_QUOTE_FUNNELS_LEADS_CALLS_DATE_RANGES: 'fetch_quote_funnels_leads_calls_date_ranges',
}

export const SF_NOTIFICATION_EVENTS = {
    // # Campaign Events
    CAMPAIGN_CREATED: 'When a new campaign is created',
    CAMPAIGN_UPDATED: 'When a campaign is updated',
    CAMPAIGN_STATUS_CHANGED: 'When campaign is activated/deactivated',
    // CAMPAIGN_ARCHIVED: 'When campaign is archived',
    CAMPAIGN_DELETED: 'When campaign is deleted',

    // # Budget Events
    DAILY_BUDGET_HIT: 'When daily budget is hit',
    MONTHLY_BUDGET_HIT: 'When monthly budget is hit',
    DAILY_BUDGET_CHANGED: 'When daily budget is changed',
    MONTHLY_BUDGET_CHANGED: 'When monthly budget is changed',

    // # Billing Events
    CREDIT_CARD_ADDED: 'When a new credit card is added',
    CREDIT_CARD_UPDATED: 'When a credit card is updated',
    ACCOUNT_AUTO_REBILLED: 'When account is auto rebilled',
    ACCOUNT_FUNDED_MANUALLY: 'When account is funded manually',
    ACCOUNT_REBILL_FAILED: "When billing fails for an account",

    // # Security Settings
    PASSWORD_CHANGED: 'When password is changed',
    MFA_UPDATED: 'When MFA is updated',
    INVOICE_AVAILABLE: 'When invoice is available',
    UNRECOGNIZED_DEVICE: 'When user is unrecognized',

    // # Account Settings
    BRAND_ADDED: 'When a new brand is added',
    USER_ADDED_OR_REMOVED: 'When a new user is added to, or removed from an account',
    // USER_REMOVED: 'When a user is removed from account',
    DAILY_CHANGE_HISTORY_AVAILABLE: 'When daily change history is available'
}

export const ACCOUNT_NOTIFICATIONS_FEATURES_SECTIONS = {
    CAMPAIGNS: "Campaigns",
    BUDGETS: "Budgets",
    BILLING: "Billing",
    SECURITY_SETTINGS: "Security Settings",
    ACCOUNT_SETTINGS: "Account Settings",
}

export const ACCOUNT_NOTIFICATIONS_FEATURES = [
    {
        active: false,
        name: ACCOUNT_NOTIFICATIONS_FEATURES_SECTIONS.CAMPAIGNS,
        features: [
            {
                "account_notifications_id": 1,
                ui_name: "New campaigns",
                description: 'When new campaigns are launched',
                name: SF_NOTIFICATION_EVENTS.CAMPAIGN_CREATED,
                active: false,
            },
            {
                "account_notifications_id": 2,
                ui_name: "Campaign updates",
                description: 'When campaigns are updated',
                name: SF_NOTIFICATION_EVENTS.CAMPAIGN_UPDATED,
                active: false,
            },
            {
                "account_notifications_id": 3,
                ui_name: "Status changes",
                description: 'When campaigns are activated/paused',
                name: SF_NOTIFICATION_EVENTS.CAMPAIGN_STATUS_CHANGED,
                active: false,
            },
            {
                "account_notifications_id": 4,
                ui_name: "Campaign deletions",
                description: 'When campaigns are deleted',
                name: SF_NOTIFICATION_EVENTS.CAMPAIGN_DELETED,
                active: false,
            },
        ]
    },
    {
        active: false,
        name: ACCOUNT_NOTIFICATIONS_FEATURES_SECTIONS.BUDGETS,
        features: [
            {
                "account_notifications_id": 5,
                ui_name: "Daily budget hit",
                description: 'When daily budgets are hit on any of the campaigns',
                name: SF_NOTIFICATION_EVENTS.DAILY_BUDGET_HIT,
                active: false,
            },
            {
                "account_notifications_id": 6,
                ui_name: "Monthly budget hit",
                description: 'When monthly budgets are hit for any of the campaigns',
                name: SF_NOTIFICATION_EVENTS.MONTHLY_BUDGET_HIT,
                active: false,
            },
            {
                "account_notifications_id": 7,
                ui_name: "Daily budget changes",
                description: 'When daily budgets are changed for any of the campaigns',
                name: SF_NOTIFICATION_EVENTS.DAILY_BUDGET_CHANGED,
                active: false,
            },
            {
                "account_notifications_id": 8,
                ui_name: "Monthly budget changes",
                description: 'When monthly budgets are changed for any of the campaigns',
                name: SF_NOTIFICATION_EVENTS.MONTHLY_BUDGET_CHANGED,
                active: false,
            },
        ]
    },
    {
        active: false,
        name: ACCOUNT_NOTIFICATIONS_FEATURES_SECTIONS.BILLING,
        features: [
            {
                "account_notifications_id": 9,
                ui_name: "Credit card updates",
                description: 'When credit card is added/updated (for credit card users only)',
                name: SF_NOTIFICATION_EVENTS.CREDIT_CARD_UPDATED,
                active: false,
            },
            {
                "account_notifications_id": 10,
                ui_name: "Manual deposits",
                description: 'When account is funded manually (for credit card users only)',
                name: SF_NOTIFICATION_EVENTS.ACCOUNT_FUNDED_MANUALLY,
                active: false,
            },
            {
                "account_notifications_id": 11,
                ui_name: "Auto rebill",
                description: 'When account is auto-rebilled (for credit card users only)',
                name: SF_NOTIFICATION_EVENTS.ACCOUNT_AUTO_REBILLED,
                active: false,
            },
            {
                "account_notifications_id": 12,
                ui_name: "Invoice",
                description: 'When new invoice is available (for invoice users only)',
                name: SF_NOTIFICATION_EVENTS.INVOICE_AVAILABLE,
                active: false,
            },
            {
                "account_notification_id": 19,
                ui_name: "Rebill failure",
                description: 'When account fails rebill (for credit card users only)',
                name: SF_NOTIFICATION_EVENTS.ACCOUNT_REBILL_FAILED,
                active: false
            }
        ]
    },
    {
        active: false,
        name: ACCOUNT_NOTIFICATIONS_FEATURES_SECTIONS.SECURITY_SETTINGS,
        features: [
            {
                "account_notifications_id": 13,
                ui_name: "Password",
                description: 'When password is changed',
                name: SF_NOTIFICATION_EVENTS.PASSWORD_CHANGED,
                active: false,
            },
            {
                "account_notifications_id": 14,
                ui_name: "Multi-factor Authentication (MFA)",
                description: 'When Multi-factor Authentication (MFA) is updated',
                name: SF_NOTIFICATION_EVENTS.MFA_UPDATED,
                active: false,
            },
            {
                "account_notifications_id": 15,
                ui_name: "New Login",
                description: 'When logged into the account from unrecognized device',
                name: SF_NOTIFICATION_EVENTS.UNRECOGNIZED_DEVICE,
                active: false,
            },
        ]
    },
    {
        active: false,
        name: ACCOUNT_NOTIFICATIONS_FEATURES_SECTIONS.ACCOUNT_SETTINGS,
        features: [
            {
                "account_notifications_id": 16,
                ui_name: "Brands",
                description: 'When new brand is launched',
                name: SF_NOTIFICATION_EVENTS.BRAND_ADDED,
                active: false,
            },
            {
                "account_notifications_id": 17,
                ui_name: "User management",
                description: 'When new users are added/deleted to/from the account',
                name: SF_NOTIFICATION_EVENTS.USER_ADDED_OR_REMOVED,
                active: false,
            },
            {
                "account_notifications_id": 18,
                ui_name: "Change history",
                description: 'Daily change history',
                name: SF_NOTIFICATION_EVENTS.DAILY_CHANGE_HISTORY_AVAILABLE,
                active: false,
            },
        ]
    }
]

export const ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS = {
    // Account Events
    ALL_STATUS_UPDATES: "When status of any account is changed",
    ASSIGNED_ACCOUNTS_STATUS_UPDATES: "When status of any assigned account is changed",

    ALL_SCHEDULED_REPORT_FAILURES: "When scheduled report fails",
    ASSIGNED_ACCOUNTS_SCHEDULED_REPORT_FAILURES: "When scheduled report fails for assigned accounts",

    ALL_LEAD_INTEGRATION_FAILURES: "When lead integration response is failure",
    ASSIGNED_ACCOUNTS_LEAD_INTEGRATION_FAILURES: "When lead integration response is failure for assigned accounts",

    // Billing Events
    ALL_BILLING_UPDATES: "When billing settings are updated on account",
    ASSIGNED_ACCOUNTS_BILLING_UPDATES: "When billing settings are updated on assigned account",

    ALL_REBILLS: "When account gets rebilled",
    ASSIGNED_ACCOUNTS_REBILLS: "When any assigned account gets rebilled",

    ALL_REBILL_FAILURES: "When account fails rebill",
    ASSIGNED_ACCOUNTS_REBILL_FAILURES: "When assigned account fails rebill",

    ALL_MANUAL_FUNDING: "When account deposits manually",
    ASSIGNED_ACCOUNTS_MANUAL_FUNDING: "When assigned account deposits manually",

    ALL_INVOICES: "When new invoice is available",
    ASSIGNED_ACCOUNTS_INVOICES: "When new invoice is available in assigned accounts",

    // Campaign Events
    ALL_BUDGETS: "When campaign hit their budget",
    ASSIGNED_ACCOUNTS_BUDGETS: "When campaigns under assigned accounts hit their budget",

    CAMPAIGN_ONE_DAY_NO_ACTIVITY: "When campaign has no activity for one day",
    ASSIGNED_ACCOUNTS_CAMPAIGN_ONE_DAY_NO_ACTIVITY: "When campaigns under assigned accounts have no activity for one day",

    MISSED_CALLS: "When call campaign receives 10 consecutive calls that are not billable",
    ASSIGNED_ACCOUNTS_MISSED_CALLS: "When call campaigns under assigned accounts receives 10 consecutive calls that are not billable",

    CREDIT_LIMIT_REACHED: "When credit limit is reached",
    ASSIGNED_ACCOUNTS_CREDIT_LIMIT_REACHED: "When credit limit is reached in assigned accounts",
}

export const ADMIN_ACCOUNT_NOTIFICATIONS_FEATURES_SECTIONS = {
    ACCOUNTS: "Accounts",
    BILLING: "Billing",
    CAMPAIGNS: "Campaigns",
}

export const INSURANCE_AGENTS_MISSED_CALLS_THRESHOLD = 2
export const DEFAULT_MISSED_CALLS_THRESHOLD = 10
export const NOTIFICATION_COUNT = isIABrand ? INSURANCE_AGENTS_MISSED_CALLS_THRESHOLD : DEFAULT_MISSED_CALLS_THRESHOLD

export const ADMIN_ACCOUNT_NOTIFICATIONS_FEATURES = [
    {
        active: false,
        name: ADMIN_ACCOUNT_NOTIFICATIONS_FEATURES_SECTIONS.ACCOUNTS,
        features: [
            {
                "admin_notification_type_id": 1,
                ui_name: "Account status",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_STATUS_UPDATES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_STATUS_UPDATES,
                description: "Notify me when account status is changed on any account",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 2,
                ui_name: "Assigned accounts status",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_STATUS_UPDATES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_STATUS_UPDATES,
                description: "Notify me when account status is changed on any accounts assigned to me",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 19,
                ui_name: "Schedule report failures",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_SCHEDULED_REPORT_FAILURES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_SCHEDULED_REPORT_FAILURES,
                description: "Notify me when scheduled report fails",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 20,
                ui_name: "Schedule report failures for assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_SCHEDULED_REPORT_FAILURES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_SCHEDULED_REPORT_FAILURES,
                description: "Notify me when scheduled report for assigned accounts fails",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 21,
                ui_name: "Lead integration failures",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_LEAD_INTEGRATION_FAILURES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_LEAD_INTEGRATION_FAILURES,
                description: "Notify me when lead integration response is failure",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 22,
                ui_name: "Lead integration failures for assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_LEAD_INTEGRATION_FAILURES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_LEAD_INTEGRATION_FAILURES,
                description: "Notify me when lead integration response is failure for assigned accounts",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            }
        ]
    },
    {
        active: false,
        name: ADMIN_ACCOUNT_NOTIFICATIONS_FEATURES_SECTIONS.BILLING,
        features: [
            {
                "admin_notification_type_id": 3,
                ui_name: "Billing settings",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_BILLING_UPDATES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_BILLING_UPDATES,
                description: "Notify me when billing settings are updated on any account",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 4,
                ui_name: "Billing settings of assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_BILLING_UPDATES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_BILLING_UPDATES,
                description: "Notify me when billing settings are updated on any accounts assigned to me",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 5,
                ui_name: "Rebill",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_REBILLS,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_REBILLS,
                description: "Notify me when any account gets rebilled",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 6,
                ui_name: "Rebill of assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_REBILLS,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_REBILLS,
                description: "Notify me when accounts assigned to me get rebilled",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 7,
                ui_name: "Rebill failure",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_REBILL_FAILURES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_REBILL_FAILURES,
                description: "Notify me when any account fails rebill",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 8,
                ui_name: "Rebill failure of assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_REBILL_FAILURES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_REBILL_FAILURES,
                description: "Notify me when accounts assigned to me fail rebill",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 9,
                ui_name: "Manual deposits",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_MANUAL_FUNDING,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_MANUAL_FUNDING,
                description: "Notify me when any account deposits money manually",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 10,
                ui_name: "Manual deposits of assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_MANUAL_FUNDING,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_MANUAL_FUNDING,
                description: "Notify me when accounts assigned to me deposit money manually",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 11,
                ui_name: "Invoices",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_INVOICES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_INVOICES,
                description: "Notify me when new invoice is available for any account",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 12,
                ui_name: "Invoices of assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_INVOICES,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_INVOICES,
                description: "Notify me when new invoice is available for accounts assigned to me",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 23,
                ui_name: "Credit limit reached",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.CREDIT_LIMIT_REACHED,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.CREDIT_LIMIT_REACHED,
                description: "Notify me when credit limit is reached for any account",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 24,
                ui_name: "Credit limit of assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_CREDIT_LIMIT_REACHED,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_CREDIT_LIMIT_REACHED,
                description: "Notify me when credit limit is reached for accounts assigned to me",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
        ]
    },
    {
        active: false,
        name: ADMIN_ACCOUNT_NOTIFICATIONS_FEATURES_SECTIONS.CAMPAIGNS,
        features: [
            {
                "admin_notification_type_id": 13,
                ui_name: "Campaign budget",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_BUDGETS,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ALL_BUDGETS,
                description: "Notify me when any campaign hits their budget",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 14,
                ui_name: "Campaign budget of assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_BUDGETS,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_BUDGETS,
                description: "Notify me when any campaigns under accounts assigned to me hit their budget",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 15,
                ui_name: "One-day no activity",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.CAMPAIGN_ONE_DAY_NO_ACTIVITY,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.CAMPAIGN_ONE_DAY_NO_ACTIVITY,
                description: "Notify me when the campaign has not seen any activity after 24 hours have passed since the activation",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 16,
                ui_name: "One-day no activity of assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_CAMPAIGN_ONE_DAY_NO_ACTIVITY,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_CAMPAIGN_ONE_DAY_NO_ACTIVITY,
                description: "Notify me when the campaigns under accounts assigned to me have not seen any activity after 24 hours have passed since the activation",
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 17,
                ui_name: "Missed calls",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.MISSED_CALLS,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.MISSED_CALLS,
                description: `Notify me when call campaign receives ${NOTIFICATION_COUNT} consecutive calls that are not billable`,
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
            {
                "admin_notification_type_id": 18,
                ui_name: "Missed calls of assigned accounts",
                template_description: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_MISSED_CALLS,
                name: ADMIN_ACCOUNT_NOTIFICATIONS_EVENTS.ASSIGNED_ACCOUNTS_MISSED_CALLS,
                description: `Notify me when call campaigns under accounts assigned to me receive ${NOTIFICATION_COUNT} consecutive calls that are not billable`,
                active: false,
                is_email_notification: false,
                is_slack_notification: false
            },
        ]
    },
]

export const HOUSEHOLD_INCOME_LABELS = {
    'Below_17K': { label: 'Below $17K', value: 'Below $17,000' },
    'dollar_17K_20K': { label: '$17K - $20K', value: '$17,000 - $20,000' },
    'dollar_20K_25k': { label: '$20K - $25K', value: '$20,000 - $25,000' },
    'dollar_25K_30K': { label: '$25K - $30K', value: '$25,000 - $30,000' },
    'dollar_30K_35K': { label: '$30K - $35K', value: '$30,000 - $35,000' },
    'dollar_35K_40K': { label: '$35K - $40K', value: '$35,000 - $40,000' },
    'dollar_40K_55K': { label: '$40K - $55K', value: '$40,000 - $55,000' },
    'Over_55K': { label: 'Over $55K', value: 'Over $55,000' }
}

export const CAMPAIGN_LEVEL_TRACKING_MEG_FOR_ADGROUP = "Please assign tracking URL in the ad group settings. This campaign will not receive traffic until tracking is assigned.";

export const modify_sf_filters_label_ui = (sf_constants) => {
    switch (sf_constants) {
        case HOUSEHOLD_INCOME_LABELS.Below_17K.value:
            return HOUSEHOLD_INCOME_LABELS.Below_17K.label
            break;
        case HOUSEHOLD_INCOME_LABELS.dollar_17K_20K.value:
            return HOUSEHOLD_INCOME_LABELS.dollar_17K_20K.label
            break;
        case HOUSEHOLD_INCOME_LABELS.dollar_20K_25k.value:
            return HOUSEHOLD_INCOME_LABELS.dollar_20K_25k.label
            break;
        case HOUSEHOLD_INCOME_LABELS.dollar_25K_30K.value:
            return HOUSEHOLD_INCOME_LABELS.dollar_25K_30K.label
            break;
        case HOUSEHOLD_INCOME_LABELS.dollar_30K_35K.value:
            return HOUSEHOLD_INCOME_LABELS.dollar_30K_35K.label
            break;
        case HOUSEHOLD_INCOME_LABELS.dollar_35K_40K.value:
            return HOUSEHOLD_INCOME_LABELS.dollar_35K_40K.label
            break;
        case HOUSEHOLD_INCOME_LABELS.dollar_40K_55K.value:
            return HOUSEHOLD_INCOME_LABELS.dollar_40K_55K.label
            break;
        case HOUSEHOLD_INCOME_LABELS.Over_55K.value:
            return HOUSEHOLD_INCOME_LABELS.Over_55K.label
            break;
        default: return sf_constants
            break;
    }
}

export const CAMPAIGN_BY_ID_API_TYPE = {
    FETCH_AD_GROUPS: 'fetch_ad_groups',
    FETCH_SOURCE_SETTINGS: 'fetch_source_settings',
    FETCH_CAMPAIGN_STATS: 'fetch_campaign_stats'
}

export const FEATURE_FLAG_STATES = {
    ON: 'ON',
    OFF: 'OFF',
    PARTIAL: 'PARTIAL',
}

export const cardDigits = [
    {
        image: americanImage,
        numbers: ['37', '34'],
    },
    {
        image: dinersClubImage,
        numbers: ['30', '36', '38', '39'],
    },
    {
        image: discoverImage,
        numbers: ['60', '64', '65']
    },
    {
        image: jcbImage,
        numbers: ['35']
    },
    {
        image: visaImage,
        numbers: ['4']
    },
    {
        image: mastercardImage,
        numbers: ['5', '2']
    }
]

export const MAP_EITHER_AND_BOTH = {
    "Either": 'Both',
    "Both": 'Either'
}


export const EMAIL_CATEGORIES = {
    OTP: 'OTP',
    ADMIN_PASSWORD_RESET: 'Admin Password Reset',
    CLIENT_PASSWORD_RESET: 'Client Password Reset',
    ADMIN_INVITATION: 'Admin Invitation',
    CLIENT_INVITATION: 'Client Invitation',
    EXCEPTION_EMAIL: 'Exception Email',
    SCHEDULED_REPORT: 'Scheduled Report',
    NOTIFICATION_EMAIL: 'Notification email',
    ACCOUNT_NOTIFICATION: 'Account Notification'
}
export const REDUCER_STATUS = {
    OK: 'ok',
    ERROR: 'error',
    UNKNOWN: 'unknown'
}


export const SF_PAYLOAD_FORMATTERS = [
    {
        formatter_name: "Date(MM/DD/YYYY)",
        formatter_type: "date",
        formatter_description: "Formats the date in MM/DD/YYYY format",
    },
    {
        formatter_name: "Date(DD/MM/YYYY)",
        formatter_type: "date",
        formatter_description: "Formats the date in DD/MM/YYYY format",
    },
    {
        formatter_name: "Date(YYYY/MM/DD)",
        formatter_type: "date",
        formatter_description: "Formats the date in YYYY/MM/DD format",
    },
    {
        formatter_name: "Capitalize Text",
        formatter_type: "text",

        formatter_description: "Capitalizes the first letter of each word",
    },
    {
        formatter_name: "Lowercase Text",
        formatter_type: "text",

        formatter_type: "text",

        formatter_description: "Converts all letters to lowercase",
    },
    {
        formatter_name: "Uppercase Text",
        formatter_type: "text",

        formatter_description: "Converts all letters to uppercase",
    },
    {
        formatter_name: "Remove Spaces",
        formatter_type: "text",

        formatter_description: "Removes all spaces from the text, except for spaces between words",
    },
    {
        formatter_name: "Remove Html Tags",
        formatter_type: "text",
        formatter_description: "Removes all html tags from text",
    },



]

export const NAME_OF_INTEGRATIONS = {
    CONNECTOR: {
        NAME: "Connector",
        ID: "connector"
    },
    API_FIELDS: {
        NAME: "Api Fields",
        ID: "api_fields"
    },
    RESPONSE_TYPE: {
        NAME: "Response Type",
        ID: "response_type"
    },
    REQUEST_HEADERS: {
        NAME: "Request Headers",
        ID: "lead_integration_req_headers"
    },
    TEST_INTEGRATION: {
        NAME: "Test Integration",
        ID: "test_integration"
    },
    ADMIN_SETTINGS: {
        NAME: "Admin Settings",
        ID: "admin_setting"
    }
}

export const REQUEST_CONTENT_TYPE = {
    JSON: 'application/json',
    XML: 'application/xml',
    SOAP: 'application/soap+xml',
    HTTP: 'application/x-www-form-urlencoded',
}

export const integration_accordion_state = {
    [NAME_OF_INTEGRATIONS.CONNECTOR.ID]: false,
    [NAME_OF_INTEGRATIONS.API_FIELDS.ID]: false,
    [NAME_OF_INTEGRATIONS.RESPONSE_TYPE.ID]: false,
    [NAME_OF_INTEGRATIONS.TEST_INTEGRATION.ID]: false,
}

export const LEAD_INTEGRATION_STATUS = {
    DRAFT: 'draft',
    ACTIVE: 'active',
    PAUSED: 'paused'
}

export const LEAD_INTEGRATION_UI_TAGS = {
    DRAFT: 'draft',
    TEMPLATE: 'template',
    INTERMEDIATE: 'intermediate'
}

const INITIAL_INTEGRATION_REQ_PAYLOADS = [
    {
        "lead_type_id": 1,
        "data": ""
    },
    {
        "lead_type_id": 2,
        "data": ""
    },
    {
        "lead_type_id": 3,
        "data": ""
    },
    {
        "lead_type_id": 4,
        "data": ""
    },
    {
        "lead_type_id": 5,
        "data": ""
    },
    {
        "lead_type_id": 6,
        "data": ""
    },
    {
        "lead_type_id": 7,
        "data": ""
    },
    {
        "lead_type_id": 9,
        "data": ""
    }
]

// Adding group health req payload for benepath
const INITIAL_INTEGRATION_REQ_PAYLOADS_FOR_BENEPATH = [
    ...INITIAL_INTEGRATION_REQ_PAYLOADS,
    {
        "lead_type_id": 12,
        "data": ""
    }
]

export const INITIAL_INTEGRATION = {
    "lead_integration": {
        "status": LEAD_INTEGRATION_STATUS.DRAFT,
        "name": "",
        "req_method": "POST",
        "req_content_type": "application/json",
        "posting_url": "",
        "lead_type": 6,
        "req_type": "json",
        "res_type": "json",
        "res_success_regex": "",
        "lead_integration_failure_reasons": [],
        "lead_integration_macros": [],
        "lead_integration_req_headers": [],
        "lead_integration_req_payloads": INITIAL_INTEGRATION_REQ_PAYLOADS,
        "accept_reject": false,
        "priority": "",
        "req_timeout": 30,
        "duplicate_as_template": false,
        "is_intermediate": false,
        "response_parser_function": ""
    }
}

// Adding group health req payload for benepath
export const INITIAL_INTEGRATION_FOR_BENEPATH = {
    ...INITIAL_INTEGRATION,
    lead_integration: {
        ...INITIAL_INTEGRATION.lead_integration,
        lead_integration_req_payloads: INITIAL_INTEGRATION_REQ_PAYLOADS_FOR_BENEPATH
    }
}

export const SYNDI_CLICK_NETWORKS = [
    { label: "MediaAlpha", value: 12166 },
    { label: "Surehits", value: 12063 },
    { label: "Transparently", value: 12188 },
    { label: "Contactability", value: 12104 },
    { label: "EverQuote", value: 12247 },
    { label: "EverQuote RTB", value: 12253 },
    { label: "Insurance.io", value: 12292 },
    { label: "Quote Wizard RTB", value: 12328 },
    { label: "MT Leads RTB", value: 12293 },
    { label: "Checkout Goal", value: 12371 },
]

export const SPEAKER_OPTIONS = [
    { value: "Agent", label: "Agent" },
    { value: "Customer", label: "Customer" },
    { value: "Both", label: "Both" },
]

export const API_FIELDS_TYPES_FOR_INTEGRATIONS = {
    HTTP: "HTTP",
    SOAP: "SOAP",
    JSON: "JSON",
    XML: "XML",
}

export const CLICK_CONVERSION_LOGS_STATUS = {
    PENDING: 'pending',
    CONVERSIONS_CREATED: 'conversions_created',
    FILE_UPLOADED: 'file_uploaded',
    CONVERSIONS_CREATED_FILE_UPLOADED: 'conversions_created_file_uploaded',
    FAILED: 'failed',
}

export const CLICK_CONVERSION_LOGS_DELETION_STATUS = {
    NOT_DELETED: 'not-deleted',
    IN_PROGRESS: 'in-progress',
    COMPLETED: 'completed',
    FAILED: 'failed'
}

export const STATUS_TYPES = {
    PENDING: 'pending',
    COMPLETED: 'completed',
    IN_PROGRESS: 'in-progress',
    FAILED: 'failed',
    NO_ANSWER: 'no-answer',
    BUSY: 'busy'
}

export const NEW_STATUS_TYPES = {
    PENDING: 'pending',
    COMPLETED: 'completed',
    IN_PROGRESS: 'in-progress',
    FAILED: 'failed',
    NO_ANSWER: 'no-answer',
    BUSY: 'busy',
    MULTIPLE_CALLS: 'multiple_calls'
}

export const DEFAULT_TABLE_SORT_BY_CREATED_AT_IN_DESC = [{
    dataField: SF_INVOICE_CONSTANTS.CREATED_AT,
    order: ORDER_BY.DESC,
}];

export const KEY_CODES = {
    ENTER: 13,
    TAB: 9,
    COMMA: 188,
    DELETE: 8,
}

export const KEY_NAMES = {
    ENTER: 'Enter',
    NUMERIC_PAD_ENTER: 'NumpadEnter',
}

export const SUCCESS_OPT_CONST = {
    EQUAL: 'EQUAL',
    NOT_EQUAL: 'NOT_EQUAL',
    IN: 'IN',
    NOT_IN: 'NOT_IN',
    SELECT_ALL: 'SELECT_ALL',
    NOT_NULL: 'NOT_NULL'
}

export const SUCCESS_OPTIONS = [
    { label: 'Equal To', value: SUCCESS_OPT_CONST.EQUAL },
    { label: 'Not Equal To', value: SUCCESS_OPT_CONST.NOT_EQUAL },
    { label: 'In', value: SUCCESS_OPT_CONST.IN },
    { label: 'Not In', value: SUCCESS_OPT_CONST.NOT_IN },
    { label: 'Select All', value: SUCCESS_OPT_CONST.SELECT_ALL },
    { label: 'Not Null', value: SUCCESS_OPT_CONST.NOT_NULL },

]

export const CONVERSION_UPLOAD_EVENTS = {
    OVERWRITE: { label: 'Overwrite', value: 0 },
    NEW: { label: 'New', value: 1 },
}

export const statusOptions = [
    { label: "Active", value: true },
    { label: "Paused", value: false }
];

export const COMPARISON_FIELD_OPTIONS = [
    { label: 'Greater Than', value: "Greater Than" },
    { label: 'Less Than', value: "Less Than" },
    { label: 'Equal To', value: "Equal To" }
]

export const CONVERSION_UPLOAD_REQUIRED_FIELDS = {
    CLICK_ID: { label: 'Click ID', value: 'click_id', productTypeId: PRODUCT_TYPE_IDS.CLICKS },
    LEAD_ID: { label: 'Lead ID', value: 'lead_id', productTypeId: PRODUCT_TYPE_IDS.LEADS },
    CALLER_ID: { label: 'Caller ID', value: 'caller_id', productTypeId: PRODUCT_TYPE_IDS.CALLS },
}

export const CONVERSION_UPLOAD_REQUIRED_FIELDS_VALUES = Object.values(CONVERSION_UPLOAD_REQUIRED_FIELDS).map((field) => field.value);

export const LEAD_REFUND_MAX_DAYS = 14;

export const DEFAULT_INTEGRATION_ADD_CAMPAIGN = {
    label: null,
    value: null,
    config: ''
}
export const LEAD_REFUND_DELAY_FOR_STATUS_IN_MINUTES = 2;

export const TOOLTIPS = {
    SEARCHES: 'The number of Queries Bid on, may be lower than queries because of campaign targeting settings',
    CLICK_IMPRESSIONS: 'Ad impressions',
    QUERIES: 'Number of opportunities that matched geo targeting requirements',
    BIDS: 'Number of opportunities you bid on',
    BID_RATE: 'Percentage of opportunities you are bidding on',
    ACCEPT_RATE: 'Percentage of leads we posted that you accepted',
    POSTS: 'Number of leads we attempted to post.',
    AVG_BID: 'Average bid',
    TOTAL_LEADS: 'Total leads generated',
    TOTAL_CALLS: 'Total calls generated',
    CONVERSION_PIXELS: {
        STATUS: 'Whether pixel is currently active or disabled',
        NAME: 'Name of the pixel',
        DESCRIPTION: 'Description of the pixel',
        CONVERSIONS: 'The number of conversions associated with the pixel',
        CHANNEL: 'How pixel was uploaded either manually or via API',
    },
    CONVERSION_LOGS: {
        FILE_NAME: 'Name of file that was uploaded',
        STATUS: 'Status of uploaded file',
        PRODUCT: 'Type of product of uploaded file',
        EVENT: 'Displays whether upload was new or an update',
        PROGRESS: 'Progress of file upload',
        TOTAL_RECORDS: 'Number of records uploaded',
        TOTAL_REVENUE: 'Total revenue uploaded',
        PIXEL_NEW: 'Number of new records uploaded',
        PIXEL_UPDATED: 'Number of records updated',
        PIXEL_INVALID: 'Number of records that failed due to invalid data',
        TIME: 'Date and time file was uploaded',
    },
    CAMPAIGNS: {
        GENERIC: {
            AVG_BID: 'Average across all the bids for this campaign',
            CPX: 'Cost per opportunity',
            SPEND: 'Total spend for the campaign',
            PACE: 'Estimate of spend for current month',
            NOTES: 'Notes can be used by admins to stay organized. It is not visible to the client.',
            LEAD_AND_CALL_NOTES: 'Notes can be used to stay organized.',
            PII: 'Percentage of pings that have PII data',
            FULL_DATA: 'Percentage of pings that have full data'
        },
        CLICKS: {
            BIDS: 'Number of bids submitted',
            TOTAL_CLICKS: 'Number of clicks you have received',
            CTR: 'Click through rate',
            SPEND: 'Total spend for the campaign',
            INVENTORY: 'Total Inventory available for this product/type/state(s)',
            QUERIES: 'Number of opportunities that matched geo targeting requirements',
            TARGET_RATE: 'Percentage of inventory that matched geo targeting requirements',
            SEARCHES: 'Number of bids submitted',
            BID_RATE: 'Percentage of opportunities you are bidding on',
            BIDS_WON: 'Impressions',
            EPW: 'Earning per win',
            WIN_RATE: 'Percentage of bids that won',
            ACCEPTED: 'Clicks',
            SUCCESS_RATE: 'Click through rate',
            AVG_BID: ' Average across all the bids for this campaign',
            COST_PER: 'Cost per click',
            PREFILL_SUCCESS: 'Percentage of prefill requests that are successful',
        },
        CALLS: {
            INVENTORY: 'Total Inventory available for this product/type/state(s)',
            QUERIES: 'Number of opportunities that matched geo targeting requirements',
            TARGET_RATE: 'Percentage of inventory that matched geo targeting requirements',
            SEARCHES: 'Number of bids submitted',
            BID_RATE: 'Percentage of opportunities you are bidding on',
            BIDS_WON: 'Transfers',
            EPW: 'Earning per win',
            WIN_RATE: 'Percentage of bids that won',
            ACCEPTED: 'Billable calls',
            SUCCESS_RATE: 'Billable rate',
            AVG_BID: ' Average across all the bids for this campaign',
            COST_PER: 'Cost per call',
            SPEND: 'Total spend for the campaign',
            TRANSFERS: 'Total number of calls you received',
            QUALIFIED_CALLS: 'Number of billable calls you were charged for',
            QUALIFICATION_RATE: 'Billable calls rate',
            CPC: 'Cost per billable call',
            AVG_DURATION: 'Average call duration of billable/qualified calls',
            WAIT_TIME: 'Elapsed time between transfer and buyer pick up (answer)',
        },
        LEADS: {
            POSTS: 'Number of leads we attempted to post',
            ACCEPTED_LEADS: 'Number of leads successfully posted',
            ACCEPT_RATE: 'Lead acceptance rate',
            CPL: 'Cost per lead',
            BIDS_WON: 'Posts',
            INVENTORY: 'Total Inventory available for this product/type/state(s)',
            QUERIES: 'Number of opportunities that matched geo targeting requirements',
            TARGET_RATE: 'Percentage of inventory that matched geo targeting requirements',
            SEARCHES: 'Number of bids submitted',
            BID_RATE: 'Percentage of opportunities you are bidding on',
            EPW: 'Earning per win',
            WIN_RATE: 'Percentage of bids that won',
            AVG_BID: ' Average across all the bids for this campaign',
            COST_PER: 'Cost per lead',
            SPEND: 'Total spend for the campaign',
        },
        ADMIN_SETTINGS: {
            PUB_AID: 'Adds tracking for publisher affiliate ID',
            PUB_CID: 'Adds tracking for publisher campaign ID',
            PAYOUT_TYPE: 'How we pay publishers for the calls',
            BILLABLE_DURATION: 'Number of seconds into a call when it becomes billable',
            BILLABLE_DURATION_TYPE: 'Raw billable duration starts as soon as we receive the call. Connection billable duration starts only after the call is transferred to the client.',
            DUPE_DAYS: 'Number of days for duplicate logic based on which we will pay for duplicate calls',
            MAX_BID: 'The maximum amount we want to bid on',
            CONCURRENCY: 'The number of calls an account can receive at once',
            TRANSFER_TYPE: 'Refers to the type of incoming phone call. It can be warm, cold, blind or any',
            REV_SHARE_PERCENTAGE: 'How much revenue we want to share with publishers',
            CALL_CENTER_REVIEW: 'Forwards the call to our in-house call center before sending it to clients',
            DATA_RELEASE_DURATION: 'Number of seconds into the call when we release the data',
            THROTTLE: 'Seconds in between click delivery',
            CALL_RECORDING: 'Records the call conversation'
        }
    }
}

export const LEADS_STATUS_OPTIONS = [
    { value: 'Received - not worked yet', label: 'Received - not worked yet' },
    { value: 'Attempted Contact', label: 'Attempted Contact' },
    { value: 'Contacted', label: 'Contacted' },
    { value: 'Quoted with Contact', label: 'Quoted with Contact' },
    { value: 'Quoted without Contact', label: 'Quoted without Contact' },
    { value: 'Sold - 1 Policy', label: 'Sold - 1 Policy' },
    { value: 'Sold - Multi Policy', label: 'Sold - Multi Policy' },
    { value: 'Lost - Not Interested', label: 'Lost - Not Interested' },
    { value: 'Interested - Working', label: 'Interested - Working' },
    { value: 'Interested - Future Prospect', label: 'Interested - Future Prospect' },
]

export const CALLS_STATUS_OPTIONS = [
    { value: 'Transferred', label: 'Transferred' },
    ...LEADS_STATUS_OPTIONS
]

// CPA Optimizer disposition vocabulary (shared with the backend
// update_prospect_disposition API). Labels are the pills shown in the table;
// values are the disposition strings persisted on the lead.
export const CPA_DISPOSITION_LABELS = {
    quoted: 'Quoted',
    sold_1_policy: 'Sold - 1 Policy',
    sold_multi_policy: 'Sold - Multi Policy'
}

export const CPA_DISPOSITION_VALUES = {
    QUOTED: 'Quoted',
    QUOTED_WITH_CONTACT: 'Quoted with Contact',
    SOLD_1_POLICY: 'Sold - 1 Policy',
    SOLD_MULTI_POLICY: 'Sold - Multi Policy',
    QUOTED_WITHOUT_CONTACT: 'Quoted without Contact',
    INTERESTED_WORKING: 'Interested - Working',
    INTERESTED_FUTURE_PROSPECT: 'Interested - Future Prospect'
}

// A pill can map to several underlying dispositions (e.g. "Quoted" covers all
// quote-stage values); the first value is used when the pill is selected.
export const CPA_DISPOSITION_BUCKETS = [
    {
        value: [
            CPA_DISPOSITION_VALUES.QUOTED_WITH_CONTACT,
            CPA_DISPOSITION_VALUES.QUOTED_WITHOUT_CONTACT,
            CPA_DISPOSITION_VALUES.INTERESTED_WORKING,
            CPA_DISPOSITION_VALUES.INTERESTED_FUTURE_PROSPECT
        ],
        label: CPA_DISPOSITION_LABELS.quoted
    },
    { value: [CPA_DISPOSITION_VALUES.SOLD_1_POLICY], label: CPA_DISPOSITION_LABELS.sold_1_policy },
    { value: [CPA_DISPOSITION_VALUES.SOLD_MULTI_POLICY], label: CPA_DISPOSITION_LABELS.sold_multi_policy },
]

export const CPA_DISPOSITION_OPTIONS = [
    { value: CPA_DISPOSITION_VALUES.QUOTED_WITH_CONTACT, label: CPA_DISPOSITION_LABELS.quoted },
    { value: CPA_DISPOSITION_VALUES.SOLD_1_POLICY, label: CPA_DISPOSITION_LABELS.sold_1_policy },
    { value: CPA_DISPOSITION_VALUES.SOLD_MULTI_POLICY, label: CPA_DISPOSITION_LABELS.sold_multi_policy },
]

export const LEADS_CALLS_STATUS_DEFAULT_VALUE = {
    RECEIVED_NOT_WORKED_YET: 'Received - not worked yet',
    TRANSFERRED: 'Transferred',
}

export const DailyBudgetType = [
    {
        label: '',
        options: [
            { id: 1, label: 'Unlimited', value: 'Unlimited' },
            { id: 2, label: 'Daily Budget', value: 'Daily Budget' },
            { id: 3, label: 'Budget by Day', value: 'Budget by Day' },
            { id: 4, label: 'Daily Volume', value: 'Daily Volume' },
            { id: 5, label: 'Volume by Day', value: 'Volume by Day' },
        ],
    },
];
export const MonthlyBudgetType = [
    {
        label: '',
        options: [
            { id: 1, label: 'Unlimited', value: 'Unlimited' },
            { id: 2, label: 'Monthly Budget', value: 'Monthly Budget' },
            { id: 3, label: 'Monthly Volume', value: 'Monthly Volume' },
        ],
    },
];

export const CALL_TRANSFER_TYPE_OPTIONS = [
    { label: 'cold', value: 0 },
    { label: 'blind', value: 1 },
    { label: 'warm', value: 2 },
    { label: 'any', value: 3 },
];

export const OPTIONS_CALL_ORIGINATION_TYPE = [
    { label: "Any", value: 0 },
    { label: "Inbound", value: 1 },
    { label: "Outbound", value: 2 }
];

export const AD_GROUPS_SOURCE_SETTINGS_FILTERS = {
    STATUS: 'status',
    TIMEFRAME: 'timeframe',
    DISTRIBUTION: 'distribution'  // Add this new constant
}

export const DROPDOWN_EVENTS = {
    ON_SAVE: 'on_save',
    ON_RESET: 'on_reset',
    ENTER: 'enter',
}

export const SIC_CODE = 'SIC Code';

export const NAICS_CODE = 'NAICS Code';

export const SIC8_CODE = 'SIC8 Code';

export const SIC_CODE_LABELS = [SIC8_CODE, SIC_CODE, NAICS_CODE];

export const ZIP_TIER = 'Zip Tiers';

export const CURRENT_CARRIER = 'Current Carrier';

export const acceptUnknownOptions = [
    { value: true, label: "Accept" },
    { value: false, label: "Reject" },
]

export const convertStringifiedNullToNull = (obj) => {
    for (let key in obj) {
        if (obj[key] === "null") {
            obj[key] = null;
        }
    }
    return obj
}

export const ALL_PRODUCTS_OPTION_LABEL = 'All Products'

export const PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN =
{
    LEADS: "Leads",
    CALLS: "Calls",
    ADMIN_CLIENTS: "admin_clients",
    PROSPECTS: 'Prospects',
    CAMPAIGNS: 'campaigns',
    CLICKS_DASHBOARD: 'clicks_dashboard',
    LEADS_DASHBOARD: 'leads_dashboard',
    CALLS_DASHBOARD_FOR_STATES: 'calls_dashboard_for_states',
    CALLS_DASHBOARD_FOR_CAMPAIGNS: 'calls_dashboard_for_campaigns',
    ADGROUP: 'adgroup',
    SOURCE_SETTING: 'source_setting',
    PROFILE: 'profile',
    LEADS_CALLS_SOURCE_SETTING: 'leads_calls_source_setting',
    ANALYTICS: 'analytics',
    CONVERSION_LOGS: 'conversion_logs',
    CALLS_DASHBOARD: 'calls_dashboard',
    SYNDI_CLICKS_DASHBOARD: 'syndi_clicks_dashboard',
    QUOTE_FUNNEL_DASHBOARD: 'quote_funnel_dashboard',
    ADMIN_ANALYTICS: 'admin_analytics',
    USER_ACTIVITY: 'user_activity'
}

export const sortColumnsByOrder = (columns, columnsOrder) => {
    // Create a copy of the columns array to avoid modifying the original array
    const sortedColumns = [...columns];

    // Sort the columns based on the columnsOrder object
    sortedColumns.sort((a, b) => {
        const columnNameA = a.columnName;
        const columnNameB = b.columnName;
        if (a.dataField === 'options' || a.dataField === 'action') {
            return 1
        }
        else if (b.dataField === 'options' || b.dataField === 'action') {
            return -1
        }
        // Check if the column names exist in the columnsOrder object
        else if (columnNameA in columnsOrder && columnNameB in columnsOrder) {
            // Compare the order values from columnsOrder
            return columnsOrder[columnNameA] - columnsOrder[columnNameB];
        } else if (columnNameA in columnsOrder) {
            // If only A is in columnsOrder, move it ahead
            return 1;
        } else if (columnNameB in columnsOrder) {
            // If only B is in columnsOrder, move it ahead
            return -1;
        }
        else {
            // If neither A nor B are in columnsOrder, maintain their relative order
            return 0;
        }
    });

    return sortedColumns;
}

export const QUOTE_FUNNEL = {
    COMPONENT_TYPE: {
        'TEXT': 'text',
        'SINGLE_SELECT': 'single_select',
        'MULTI_SELECT': 'multi_select',
        'RADIO': 'radio',
        'CHECKBOX': 'checkbox',
        'SELECT_BOX': 'select_box',
        'TEXTAREA': 'textarea',
        'DATE': 'date',
        'TIME': 'time',
        'DATETIME': 'datetime',
        'FILE': 'file',
        'IMAGE': 'image',
        'NUMBER': 'number',
        'EMAIL': 'email',
        'URL': 'url',
        'PASSWORD': 'password',
        'BOOLEAN': 'boolean',
        'PHONE_NUMBER': 'phone_number',
        "BOOLEAN_WITH_DISPLAY": 'boolean_with_display',
        "ADDRESS": 'address'
    },

}

export const AGENT_PROFILE_IMG = {
    PROFILE_IMG: 'profile_img',
    COMPANY_LOGO_IMG: 'company_logo_img'
}

export const QUOTE_FUNNEL_QUESTION_DEPENDS_ON_TYPE = {
    EQUAL_TO: 'equal_to',
    GREATER_THAN: 'greater_than',
    LESS_THAN: 'less_than',
    NOT_NULL: 'not_null',
    INCLUDES_IN_ARRAY: 'includes_in_array',
    NOT_EQUAL_TO: 'not_equal_to'
}

export const mileOptions = [50, 75, 100, 200];

const timeOptions = [
    '12:00AM', '1:00AM', '2:00AM', '3:00AM', '4:00AM', '5:00AM', '6:00AM',
    '7:00AM', '8:00AM', '9:00AM', '10:00AM', '11:00AM', '12:00PM',
    '1:00PM', '2:00PM', '3:00PM', '4:00PM', '5:00PM', '6:00PM',
    '7:00PM', '8:00PM', '9:00PM', '10:00PM', '11:00PM'
];

export const timeOptionsValueLabel = timeOptions.map((time, index) => ({
    value: time,
    label: time,
}));
export const ADMIN_ONLY_SETTING = 'Admin only setting'
export const ADMIN_ONLY_COLUMN = 'Admin only column'
export const ADMIN_ONLY_TAB = 'Admin only tab'
export const ADMIN_ONLY_FUNCTIONALITY = 'Admin only functionality'
export const ADMIN_ONLY_FILTER = 'Admin only filter'

export const QUOTE_FUNNEL_TABLE_NAMES = {
    ACTION: 'action',
    NAME: 'name'
}

export const CONVERSION_UPLOAD_FAILURE_MESSAGES = {
    CLICK_ID_NOT_FOUND: 'Click ID not found',
    CALLER_ID_NOT_FOUND: 'Caller ID not found',
    LEAD_ID_NOT_FOUND: 'Lead ID not found'
};
export const footerLinksatQuoteFunnel = [
    { link: <a href="/privacy-policy" target='_blank' className="text-sfblue">Privacy Policy</a>, name: 'Privacy Policy' },
    { link: <a href="/terms-of-use" target='_blank' className="text-sfblue">Terms of Use</a>, name: 'Terms of Use' },
    { link: <a href="/ccpa-opt-out" target='_blank' className="text-sfblue">Do not sell my personal information</a>, name: 'Do not Sell my personal information' },
    { link: <a href="/privacy-policy#special-notice-california" target='_blank' className="text-sfblue">California Privacy Choices</a>, name: 'California Privacy Choices' },
    { link: <a href="/privacy-policy#cookies-and-technologies" target='_blank' className="text-sfblue">Cookies and Other Technology</a>, name: 'Cookies and Other Technology' }
];
export const default_hours_of_operation = [
    { day: 'sunday', is_active: false, from: '1:00AM', to: '1:00AM' },
    { day: 'monday', is_active: true, from: '1:00AM', to: '1:00AM' },
    { day: 'tuesday', is_active: true, from: '1:00AM', to: '1:00AM' },
    { day: 'wednesday', is_active: true, from: '1:00AM', to: '1:00AM' },
    { day: 'thursday', is_active: true, from: '1:00AM', to: '1:00AM' },
    { day: 'friday', is_active: true, from: '1:00AM', to: '1:00AM' },
    { day: 'saturday', is_active: false, from: '1:00AM', to: '1:00AM' }
];

export const default_products_offered = [
    { lead_type_id: '6', is_active: true },
    { lead_type_id: '1', is_active: true },
    { lead_type_id: '3', is_active: true },
    { lead_type_id: '2', is_active: true },
    { lead_type_id: '5', is_active: true }
];

export const ADDRESS_CONSTS = {
    CITY: 'city',
    ZIP: 'zip',
    STATE: 'state',
    MANUAL: 'manual',
    AUTO: 'auto'
}

export const questionTypeLabels = {
    date: 'Date',
    phone_number: 'Phone number',
    email: 'E-mail address',
    text: 'Value'
};

export const FILTER_COMPONENT_TYPES = {
    TEXT: "text",
    EMAIL: "email",
    CHECKBOX: "checkbox",
    DATE_RANGE: "date_range",
    SINGLE_SELECT: "single_select",
    MULTI_SELECT: "multi_select",
    COMPARATOR: "comparator"
}

export const QUESTION_FIELD_NAMES = {
    COVERAGE_AMOUNT: 'coverage_amount',
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',
    PHONE_NUMBER: 'primary_phone',
    SQUARE_FOOTAGE: 'square_footage'
}

export const EMAIL_HAS_ALREADY_BEEN_TAKEN = "email has already been taken";

export const bidTypeOptions = [
    { label: "Set Bid", value: "setbid" },
    { label: "Increase Bid Percentage", value: "increase" },
    { label: "Decrease Bid Percentage", value: "decrease" }
]

export const MIN_RTB_CM = -1;

export const MAX_RTB_CM = 1;

export const isValidRtbCm = (value) => {
    return value >= MIN_RTB_CM && value <= MAX_RTB_CM
}

export const NON_ISO_CHARACTERS_REGEX = /[^\u0000-\u00FF]/g;

export const hasNonISOCharacters = (str) => {
    return NON_ISO_CHARACTERS_REGEX.test(str);
};

export const STATUS_OPTIONS = {
    ACTIVE: "active",
    PAUSED: "paused",
    ONBOARDING: "onboarding",
    INACTIVE: "inactive",
    REGISTRATION_PENDING: 'registration_pending'
}

export const ERR_DEVISE_SIGNATURE_VERIFICATION_FAILED = "ERR_DEVISE_SIGNATURE_VERIFICATION_FAILED";

// Generic error message constant
export const GENERIC_ERROR_MESSAGE = 'An error occurred while processing your request';

export const RTB_ACCOUNT_ID = 5

export const LEAD_INTEGRATION_TABS = {
    TYPE: "type",
    CONFIG: "config",
    SETTINGS: "settings",
    STATS: "stats"
}

export const QF_TRACKING_CODE_CLASS_NAMES = {
    HEAD: "qf_head_tracking_script",
    BODY: "qf_body_tracking_script"
}

export const ADMIN_SMART_VIEW_FILTER_KEYS = {
    time_frame: 'time_frame',
    timezone: 'timezone',
    account_ids: 'account_ids',
    campaign_ids: 'campaign_ids',
    lead_type_ids: 'lead_type_ids',
    brand_ids: 'brand_ids',
    marketing_groups: 'marketing_groups',
    states: 'states',
    ad_group_ids: 'ad_group_ids',
    ad_ids: 'ad_ids',
    source_type_ids: 'source_type_ids',
    device_types: 'device_types',
    account_manager_ids: 'account_manager_ids',
    salesperson_ids: 'salesperson_ids',
    carrier_ids: 'carrier_ids',
    compare: 'compare',
    prev_time_frame: 'prev_time_frame',
    day_segment: 'day_segment',
    hours_of_day: 'hours_of_day'
}

export const TYPES_OF_DATA_FORMAT = {
    PERCENTAGE: 'percentage',
    COMMA: 'comma',
    DOLLAR: 'dollar',
    COMMA_WITH_TWO_DECIMAL_PLACES: 'comma_with_two_decimal_places',
    PERCENTAGE_WITH_TWO_DECIMAL_PLACES: 'percentage_with_two_decimal_places',
    TIME: 'TIME'
}

export const ADMIN_ANALYTICS_POSSIBLE_GROUP_BY_KEYS = [
    'state',
    'zip',
    'account_id',
    'brand_id',
    'marketing_group',
    'campaign_id',
    'ad_group_id',
    'day_of_week',
    'hour',
    'start_of_day',
    'start_of_week',
    'start_of_month',
    'start_of_quarter',
    'start_of_year',
    'lead_type_id',
    'source_type_id',
    'device_type',
    'currently_insured',
    'current_carrier',
    'home_owner',
    'continuous_coverage',
    'gender',
    'marital_status',
    'consumer_age',
    'education',
    'credit_rating',
    'military_affiliation',
    'num_drivers',
    'num_vehicles',
    'license_status',
    'insurance_carrier_id',
    'sales_manager_id',
    'account_manager_id',
    'insured',
    'product_type_id',
    'display_name',
    'network_id',
    'line_of_interest',
    'naics',
    'sic',
    'pii_availability',
    'annual_revenue',
    'years_in_business',
    'aid',
    'cid',
    'ks'
]
export const TOOLTIP_CONSTANTS_FOR_TEST_INTEGRATION = {
    ID_FIELD: {
        DATA_FIELD: "id",
        NAME: "ID",
        TOOLTIP_MESSAGE: "Log ID for troubleshooting purposes"
    },
    NAME_FIELD: {
        ID: "test_integration_tooltip_content_type",
        NAME: "Name",
        TOOLTIP_MESSAGE: "Name for your connector"
    },
    LEAD_TYPE: {
        ID: "test_integration_tooltip_lead_type",
        NAME: "Lead Type",
        TOOLTIP_MESSAGE: "The type of insurance lead"
    },
    CONNECTION_TYPE: {
        DATA_FIELD: "req_method",
        NAME: "Connection Type",
        TOOLTIP_MESSAGE: "Type of connection can be Post, Get, Put, or Delete"
    },
    STATUS: {
        DATA_FIELD: "res_status",
        NAME: "Status",
        TOOLTIP_MESSAGE: "Whether the test connection was successful or not"
    },
    STATUS_CODE: {
        DATA_FIELD: "success",
        NAME: "Status Code",
        TOOLTIP_MESSAGE: "Response status code from the web server"
    },
    POSTING_URL: {
        ID: "test_integration_tooltip_posting_url",
        DATA_FIELD: "posting_url",
        NAME: "Posting URL",
        TOOLTIP_MESSAGE: "Destination of a web server that accepts the data enclosed in the body of the request message"
    },
    RESPONSE: {
        DATA_FIELD: "res_body",
        NAME: "Response",
        TOOLTIP_MESSAGE: "Detailed response from the web server"
    },
    CAMPAIGNS: {
        DATA_FIELD: "campaign",
        NAME: "Campaign",
        TOOLTIP_MESSAGE: "",
        ID: "test_integration_campaign",
    }
}

export const CONSENT_TOOLTIP_MESSAGES = {
    CERTIFICATE_ID: 'Unique ID generated for this session',
    DATE: 'Date of session took place',
    DURATION: 'Time visitor spent on form',
    PAGE_URL: 'Page user visted during the session',
    IP_ADDRESS: 'User IP address',
    LOCATION: 'User location',
    BROWSER: 'Browser and operating system visitor used',
    CONSENT_CAPTURED: 'List of Insurance Carriers Checked',
    TCPA_DISCLAIMER: 'TCPA Disclaimer text',
    FORM_COMPLETED: 'The user completed the form'
}

export const BUDGETS_TYPES = {
    DOLLAR: 'dollar',
    VOLUME: 'volume',
    UNLIMITED: 'unlimited',
    NONE: 'none',
    OPEN: 'open'
}

export const ANALYTICS_POSSIBLE_GROUP_BY_KEYS = [
    'state',
    'zip',
    'brand_id',
    'marketing_group',
    'campaign_id',
    'ad_group_id',
    'ad_id',
    'day_of_week',
    'hour',
    'start_of_day',
    'start_of_week',
    'start_of_month',
    'start_of_quarter',
    'start_of_year',
    'lead_type_id',
    'source_type_id',
    'device_type',
    'insured',
    'current_carrier',
    'home_owner',
    'continuous_coverage',
    'gender',
    'marital_status',
    'consumer_age',
    'education',
    'credit_rating',
    'military_affiliation',
    'num_drivers',
    'num_vehicles',
    'multiple_vehicles',
    'bundle_home',
    'license_status',
    'violations',
    'dui',
    'accidents',
    'city',
    'county',
    'tobacco',
    'major_health_conditions',
    'life_coverage_type',
    'life_coverage_amount',
    'property_type',
    'property_age',
    'years_in_business',
    'commercial_coverage_type',
    'household_income',
    'prefill_percentage',
    'sr22',
    'line_of_interest',
    'naics',
    'sic',
    "pii_availability",
    'annual_revenue',
    'aid',
    'cid',
    'ks'
]
export const ANALYTICS_TIMEFRAME_GROUP_BY_KEYS = [
    'hour',
    'start_of_day',
    'start_of_week',
    'start_of_month',
    'start_of_quarter',
    'start_of_year'
]

export const PROSPECT_TABS = {
    CONSENT: 'consent',
    SUMMARY: 'summary'
}

export const DEFAULT_TCPA_DISCLAIMER = `<p style="text-align: justify;">
  By clicking the "Continue & Get Quote" button above, I provide my ESIGN/electronic signature and express written consent and authorization to the insurance provider/agency identified above to contact me for marketing/telemarketing purposes at the telephone number and address I have provided, using live operators, automated technology, artificial and/or AI generative voice or pre-recorded messages, SMS/MMS text messages and/or emails, if applicable, even if I have previously registered the provided my telephone number on the Federal and/or any State Do Not Call Registry. I understand that my consent is not required as a condition of obtaining goods or services and can be revoked at any time. I acknowledge that to be connected with product sellers that can fit my needs without providing this consent, I can call the number listed on this page. I represent that I am at least 18 years of age, and agree to this website's 
  <a href='{privacy_policy}' target='_blank' style="text-decoration: underline; color: #3486e5 !important;">Privacy Policy</a> and 
  <a href='{terms_of_use}' target='_blank' style="text-decoration: underline; color: #3486e5 !important;">Terms of Services</a>.
</p>
<p style="text-align: justify;">
  Message and data rates may apply. Message frequency varies. Reply HELP for customer support or STOP to opt-out. See 
  <a href='{sms_terms}' target='_blank' style="text-decoration: underline; color: #3486e5 !important;">SMS Terms of Service</a> for more details.
</p>`;


export const NO_SUMMARY_MESSAGE = "We don't have your conversation summary."

export const NO_QA_MESSAGE = "You've not asked any questions."

export const NO_DATA_MESSAGE = "No Data. Please check the timeframe or other filters."

export const TCPA_DISCLAIMER_MACROS = [
    { name: '{privacy_policy}', description: "Link to privacy policy." },
    { name: '{terms_of_use}', description: "Link to terms of use." },
    { name: '{sms_terms}', description: "Link to SMS terms." },
];

export const CONVERSATIONS_SUMMARY_STATUS = {
    PENDING: "Summary is currently unavailable for this call. Please try again later.", //AI job is yet to be run on old calls
    IN_PROGRESS: "Summary is being processed for this call. Please check back shortly.",  //AI job is still generating summary
    FAILED: "Unable to generate the summary at the moment. ", //AI job failed
}

export const ELAPSED_TIME_TYPE_OPTIONS = [
    { label: 'Greater Than', value: "Greater Than" },
    { label: 'Less Than', value: "Less Than" },
    { label: 'Between', value: "Between" }
]

export const DMS_LOGS_STATUS_OPTIONS = [
    { label: 'All', value: "All" },
    { label: 'Warning', value: "Warning" },
    { label: 'Error', value: "Error" },
]

export const RULES_STATUS_OPTIONS = [
    { label: 'All', value: "All" },
    { label: 'Passed', value: "Passed" },
    { label: 'Failed', value: "Failed" },
]


export const RULE_STATUS = {
    PASSED: 'passed',
    FAILED: 'failed',
}

export const API_STATUS_OPTIONS = [
    { label: 'All', value: 0 },
    { label: '504', value: "504" },
    { label: '200', value: "200" },
    { label: '500', value: "500" }
]

export const ADMIN_ANALYTICS_TIMEFRAME_GROUP_BY_KEYS = {
    DOW: 'day_of_week',
    HOUR: 'hour',
    DATE: 'start_of_day',
    WEEK: 'start_of_week',
    MONTH: 'start_of_month',
    QUARTER: 'start_of_quarter',
    YEAR: 'start_of_year'
}
//Please don't change this class to className
export const EDITOR_CLASS_NAME = (`class='editorLineNumber'`);

export const MAX_BUDGETS = {
    DAILY_DOLLAR: 100000,
    DAILY_VOLUME: 5000,
    MONTHLY_DOLLAR: 2500000,
    MONTHLY_VOLUME: 25000,
    WEEKEND_DISCOUNT: 100
}

export const NGINX_MAX_SIZE = 20971520;

export const STATUS_MONITOR_PROFILING_TAGS = {
    DASHBOARD: 1, //reporting subset
    DASHBOARD_CALLS_MAIN: 2,
    DASHBOARD_CALLS: 3,
    DASHBOARD_DMS_LOGS: 4,
    DASHBOARD_RDS_LOGS: 5,
    REPORTING: 6,
    CLICKS: 7,
    CALLS: 8,
    LEADS: 9,
    ANALYTICS: 10, //reporting subset
    CAMPAIGN_STATS: 11, //reporting subset
    AD_GROUP_SOURCE_SETTING_STATS: 12,
    AD_STATS: 13, //reporting subset
    BILLING: 14, //separate module
    INTEGRATION: 15, //separate module
};

export const STATUS_HISTORICAL_TIMEFRAME = {
    LAST_30_DAYS: '30days',
    LAST_24_HOURS: '24hrs',
    LAST_1_HOUR: '1hour'
}

export const customer_incident_status = [
    { name: "warning", value: "Warning" },
    { name: "error", value: "Error" },
    { name: "critical", value: "Critical" },
]

export const CUSTOMER_INCIDENT_ERROR_STATE = {
    WARNING: 'warning',
    ERROR: 'error',
    CRITICAL: 'critical'
}

export const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// Day Segment filter for the admin analytics window. Through This Hour reports
// only the hours already finished in the reporting timezone, of every day of the
// selected range. The values are the backend contract shared with the pub
// portal, inconsistent casing included, so one value serves every portal.
export const DAY_SEGMENTS = {
    FULL_DAY: 'full_day',
    THROUGH_THIS_HOUR: 'through-this-hour',
};

export const DAY_SEGMENT_OPTIONS = [
    { label: 'Full Day', value: DAY_SEGMENTS.FULL_DAY },
    { label: 'Through This Hour', value: DAY_SEGMENTS.THROUGH_THIS_HOUR },
];

// Hours of the day the analytics window can be cut to, applied to every day of
// the selected range. Hour N sits at index N, which is what lets the completed
// hours be taken as a slice.
export const HOUR_OF_DAY_OPTIONS = Array.from({ length: 24 }, (_, hour) => ({
    label: String(hour),
    value: hour,
}));

export const WHITE_LABELED_BRANDS_NAME_LOGO_MAPPING = {
    'USHA': WHITE_LABELED_PRODUCT_NAMES.USHA_IO,
    'GOAL': WHITE_LABELED_PRODUCT_NAMES.GOAL,
    'InsuranceAgents.ai': WHITE_LABELED_PRODUCT_NAMES.INSURANCEAGENTS_AI,
    'SmartFinancial Pro': WHITE_LABELED_PRODUCT_NAMES.SMARTFINANCIALPRO,
    'Benepath': WHITE_LABELED_PRODUCT_NAMES.BENEPATH,
    'SmartHub': WHITE_LABELED_PRODUCT_NAMES.SMARTHUB,
    // Displays IO logo for RTB brand
    'RTB': WHITE_LABELED_PRODUCT_NAMES.INSURANCE_IO,
}

export const OPTION_NONE = { label: 'None', value: null }

export const PAYOUT_TYPES = {
    RTB: 'RTB',
    CPC: 'CPC',
    REV_SHARE: 'REV_SHARE'
};

export const OPTIONS_PAYOUT_TYPE = [
    { label: 'RTB', value: PAYOUT_TYPES.RTB },
    // { label: 'CPC', value: PAYOUT_TYPES.CPC },
    // { label: 'Rev Share', value: PAYOUT_TYPES.REV_SHARE }
];

export const BILLABLE_DURATION_TYPES = {
    RAW: 'RAW',
    CONNECTION: 'CONNECTION'
};

export const OPTIONS_BILLABLE_DURATION_TYPE = [
    { label: 'Raw', value: BILLABLE_DURATION_TYPES.RAW },
    // { label: 'Connection', value: BILLABLE_DURATION_TYPES.CONNECTION }
];

export const OPTION_ALL = { label: 'All Brands', value: 'all' }

export const MULTI_SELECT_CHECKBOXES_CUSTOM_STYLES = {
    groupHeading: (base, _group) => {
        return {
            ...base,
            backgroundColor: "#f2f2f3",
            color: "#000",
            fontSize: "14px",
            fontWeight: "600",
            padding: "3px 12px",
            textTransform: 'none',
        };
    },
};

export const CREATIVE_ALREADY_EXIST = 'This Ad creative already exists.'

export const OPTION_ALL_WITH_EMPTY_VALUE = { label: 'All', value: '' }

export const INDEPENDENT_AGENCY = 'independent agency'

export const getProductTypeIdByName = (productName) => {
    switch (productName) {
        case NAME_OF_PRODUCT_TYPES.CLICKS:
            return PRODUCT_TYPE_IDS.CLICKS;
        case NAME_OF_PRODUCT_TYPES.CALLS:
            return PRODUCT_TYPE_IDS.CALLS;
        case NAME_OF_PRODUCT_TYPES.LEADS:
            return PRODUCT_TYPE_IDS.LEADS;
        default:
            return null;
    }
};

export const ADMIN_DASHBOARD_REVAMP_ALL_PRODUCT_IDS = [PRODUCT_TYPE_IDS.CLICKS, PRODUCT_TYPE_IDS.CALLS, PRODUCT_TYPE_IDS.LEADS];
export const DEFAULT_CONVENIENCE_FEE_PERCENTAGE = 2.95

// Add this to the exports in the file
export const CAMPAIGN_DISTRIBUTION_FILTER_OPTIONS = [
    { label: "All", value: "" },
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
]

export const tosNameFormatter = (cellContent, downlaodUrl) => {
    return (
        <span>
            {
                cellContent
                    ? (
                        <a href={downlaodUrl} className="text-sfblue" target="_blank">
                            {cellContent}
                        </a>
                    )
                    : "--"
            }
        </span>
    )
}

export const MAX_AGENCY_INFO_LENGTH = 5000;

export const NUM_EMPLOYEES_FILTER_NAME = "Number Of Employees";
export const NUM_EMPLOYEES_FILTER_OPTION_2_TO_4 = ["2-4"];

export const CAMPAIGN_ANALYSIS_DISQUALIFICATION_CAUSE_NAME_TO_ID_MAPPING = {
    'schedule': 1,
    'source': 2,
    'filter': 3,
    'De-dupe': 4,
    'ping-post-no-bid': 5,
    'bpfm': 6
}

export const CAMPAIGN_ANALYSIS_OPTION_DISQUALIF_FEATURE_FLAG_ENABLED_CAMPAGIN_ANALYSIS_V2 = [
    { value: 'De-dupe', label: 'De-dupe' },
    { value: 'ping-post-no-bid', label: 'Ping-post no bid' },
    { value: 'bpfm', label: 'BPFM' }
];

export const TOAST_MESSAGES = {
    MISSING_DESTINATION_URL: "You must set a destination URL before activating this ad group",
    AD_GROUP_NAME_BLANK: "Ad Group name cannot be blank",
    BID_PRICE_TOO_LOW: (minPrice) => `You cannot set bid price less than $${minPrice}`,
}

// Used for stat_type with V4 Aggregated Stats API for Dashboard page
export const DASHBOARD_STAT_TYPES = {
    OVERVIEW: 'overview',
    STATES: 'states',
    SOURCES: 'sources',
    CREATIVES: 'creatives',
    INSURANCE_TYPES: 'insurance_types',
}

export const LEAD_INTEGRATION_CONFIG_MODE_DESCRIPTIONS = {
    WIZARD: 'Enter configuration values for each field below. Switch to JSON Editor tab to view the generated JSON.',
    JSON: 'Edit the JSON configuration directly.'
}

export const EXPORT_ENQUEUED_MESSAGE = "Export has been enqueued. It will be emailed to you shortly."

export const INTEGRATION_SAMPLE_LEAD_PRODUCT_OPTIONS = [
    { label: 'Clicks', value: PRODUCT_TYPE_IDS.CLICKS },
    { label: 'Leads', value: PRODUCT_TYPE_IDS.LEADS },
    { label: 'Calls', value: PRODUCT_TYPE_IDS.CALLS },
]

export const LEAD_MARKETPLACE_PRODUCT_LABEL = 'Lead Marketplace';

// SmartHub keeps its feature flags in its own Flipper store, so anything fanned out
// to these hosts lands where nothing on IO reads it.
export const FEATURE_FLAG_SYNC_EXCLUDED_BRAND_API_URLS = [
    'https://api.smarthub.insurance.io',
    'https://api.smarthub-staging.insurance.io',
];
